import React, { useEffect, useRef, useState } from 'react';
import { useAddOrderDetails, useGetAllMenu, useGetBillhtml, useGetHtmlContent, useGetOrderhtml, useUpdateOrderDetails, useGetAllMiscellaneousItems, useGetAllCategory, useUpdateMaterialData } from '../hooks/hooks';
import { showErrorToast, showSuccessToast } from '../components/common';
import { useLocation, useNavigate } from 'react-router-dom';
import useOutsideClick from '../hooks/useOutsideClick';

import moment from 'moment';
// import pdflogoSrc from './../assets/images/pdf_logo.jpeg';
import pdflogoSrc from './../assets/images/pdf_logo_transperent.png';

import pdfbackgroundSrc from './../assets/images/pdfbackground.png';
import fssai from './../assets/images/fssai.png';
import down_arrow from './../assets/images/down_arrow.svg';
import Left_arrow from './../assets/images/left-arrow.png';
import { useTranslation } from 'react-i18next';
import { getOrderbyId } from '../API/order';
import { useLoader } from '../hooks/LoaderContext';
import { BiChevronDown } from "react-icons/bi";
import DeleteModal from '../modal/DeleteModal';
import clsx from "clsx";
import Close from './../assets/images/close_icon.svg'
import { FaUser, FaPhone, FaMapMarkerAlt, FaCalendarDay, FaClipboardList, FaPrint, FaFileInvoiceDollar, FaBoxes, FaSave, FaTimes, FaSun, FaCloudSun, FaMoon, FaHotel } from 'react-icons/fa';
import AddOrder from '../modal/AddOrder';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ButtonWithIcon } from '../components/Common/Buttons';
import { DueAmountIcon, EditIcon, PaidAmountIcon, PayStatusIcon, PlusIcon, TDueAmountIcon } from '../assets/icons/icon';
import { CollapsibleCard, DataCard, InfoItem, MealServiceSection, MiscellaneousSection, NoMenuItem } from '../components/Common/DisplayInfo';
import MenuSelectionSection from '../components/Order/MenuSelectionSection';
import { InputF } from '../components/Common/CommonInput';
const codeNumberMap = { '1': 'A', '2': 'B', '3': 'C', '4': 'D', '5': 'E', '6': 'F', '7': 'G', '8': 'H', '9': 'I', '0': 'J' };
const base64Imagedata = "data:image/jpeg;base64,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"

const OrderDetail = () => {
  const { setLoading } = useLoader();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // const { selectedOrder } = location.state;
  const { mutate: getOrderhtml } = useGetOrderhtml();
  const { mutate: getHtmlContent } = useGetHtmlContent();
  const { mutate: getUpdatedMaterialURLS } = useUpdateMaterialData();
  const { mutate: getBillhtml } = useGetBillhtml();

  const [lang, setlang] = useState(localStorage.getItem('i18nextLng'));
  const [isOpenDelete, setisOpenDelete] = useState(false);
  const [isDeleteItem, setIsDeleteItem] = useState(undefined);
  const [selectedTime, setSelectedTime] = useState(undefined);
  const [isOpenPrintPreview, setIsOpenPrintPreview] = useState(false);
  const [printHtmlContent, setPrintHtmlContent] = useState('');
  const [printPdfUrl, setPrintPdfUrl] = useState('');
  const [categoryPdfsList, setCategoryPdfsList] = useState({});

  const [selectedOrder, setselectedOrder] = useState(location?.state?.selectedOrder || null);
  const { data: menuLists } = useGetAllMenu();
  const [inputValue, setInputValue] = useState({
    orderId: '',
    mPrice: '',
    mTotalPerson: '',
    mTotal: 0,
    aPrice: '',
    aTotalPerson: '',
    aTotal: 0,
    nPrice: '',
    nTotalPerson: '',
    nTotal: 0,
    bName: '',
    bPrice: '',
    bTotalPerson: '',
    bTotal: 0,
    totalAmount: 0,
    paidByClient: 0,
    dueamount: 0,

    // ✅ added
    isSimple: false,
    simpleDescription: ''
  });

  const [Error, setError] = useState({ partyName: "", farmName: "", farmAddress: "", eventDate: '' });
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [orderDetailsId, setOrderDetailsId] = useState(null);
  const [morningOptions, setMorningOptions] = useState([]);

  const [isAfternoonPopoverOpen, setAfternoonPopoverOpen] = useState(false);
  const [afternoonselectedOptions, setAfternoonSelectedOptions] = useState([]);

  const [isNightPopoverOpen, setNightPopoverOpen] = useState(false);
  const [nightSelectedOptions, setNightSelectedOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isWhatsAppLoading, setIsWhatsAppLoading] = useState(false);
  const searchInputRef = useRef(null);

  // Meal type states
  const [morningMealType, setMorningMealType] = useState('');
  const [afternoonMealType, setAfternoonMealType] = useState('');
  const [nightMealType, setNightMealType] = useState('');

  const mealTypeOptions = [
    { value: 'Regular', label: t('Regular') },
    { value: 'Jain', label: t('Jain') },
    { value: 'Swaminarayan Jain', label: t('Swaminarayan_Jain') }
  ];

  // Helper function to translate meal type value
  const translateMealType = (mealType) => {
    if (!mealType) return '';
    const mealTypeMap = {
      'Regular': t('Regular'),
      'Jain': t('Jain'),
      'Swaminarayan Jain': t('Swaminarayan_Jain')
    };
    return mealTypeMap[mealType] || mealType;
  };

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isEditItem, setIsEditItem] = useState(undefined);

  // Miscellaneous states
  const { data: allMiscellaneousItems } = useGetAllMiscellaneousItems();
  const [morningMisc, setMorningMisc] = useState([]);
  const [afternoonMisc, setAfternoonMisc] = useState([]);
  const [nightMisc, setNightMisc] = useState([]);
  const [isMiscModalOpen, setIsMiscModalOpen] = useState(false);
  const [miscSection, setMiscSection] = useState(null); // 'morning' | 'afternoon' | 'night'
  const [tempMiscSelection, setTempMiscSelection] = useState([]);
  const [miscSort, setMiscSort] = useState('name-asc');
  const { data: fetchedCategories } = useGetAllCategory();

  const categoryList = [
    { _id: "all", categoryNameEn: "All", categoryName: "All" },
    ...(fetchedCategories || [])
  ];

  const [orderList, setOrderList] = useState(null);
  const [printHtmlWithPlaceholders, setPrintHtmlWithPlaceholders] = useState('');
  const [editableQuantities, setEditableQuantities] = useState([]); // Store {id, value, unit}
  const editableContentRef = useRef(null);
  const quantityIdCounter = useRef(0);

  // Unit mapping for Gujarati to English
  const unitMapping = {
    'કિગ્રા': 'kgs',
    'ગ્રામ': 'gram',
    'નંગ': 'pieces',
    'લિટર': 'liter',
    'મિલીલીટર': 'ml',
    'KGS': 'kgs',
    'Gram': 'gram',
    'Pieces': 'pieces',
    'Liter': 'liter',
    'ML': 'ml'
  };

  const unitDisplayMap = {
    'kgs': 'કિગ્રા',
    'gram': 'ગ્રામ',
    'pieces': 'નંગ',
    'liter': 'લિટર',
    'ml': 'મિલીલીટર'
  };

  // Parse HTML and extract quantities, replace with placeholders
  // const parseHtmlForQuantities = (html) => {
  //     if (!html) return { processedHtml: '', quantities: [] };

  //     const quantities = [];
  //     let processedHtml = html;
  //     quantityIdCounter.current = 0;

  //     // Pattern to match: number (with decimals) followed by unit (Gujarati or English)
  //     // Matches patterns like: "15 કિગ્રા", "23.500 કિગ્રા", "35 નંગ", etc.
  //     // Updated pattern to match Gujarati units more accurately
  //     const gujaratiUnits = ['કિગ્રા', 'ગ્રામ', 'નંગ', 'લિટર', 'મિલીલીટર'];
  //     const englishUnits = ['KGS', 'Gram', 'Pieces', 'Liter', 'ML', 'kgs', 'gram', 'pieces', 'liter', 'ml'];
  //     const allUnits = [...gujaratiUnits, ...englishUnits];
  //     const unitPattern = allUnits.join('|');
  //     const quantityPattern = new RegExp(`(\\d+\\.?\\d*)\\s*(${unitPattern})`, 'g');
  //     console.log(quantityPattern);

  //      const internalSpanRegex = /<span\s+data-internal-id=['"]([^'"]+)['"][^>]*>(\d+\.?\d*)\s*([^<\s]+)[^<]*<\/span>/g;

  //     processedHtml = processedHtml.replace(quantityPattern, (match, value, unit) => {
  //         const id = `qty_${quantityIdCounter.current++}`;
  //         const normalizedUnit = unitMapping[unit] || unit.toLowerCase();

  //         quantities.push({
  //             id,
  //             value: parseFloat(value),
  //             unit: normalizedUnit,
  //             originalMatch: match,
  //         });

  //         return `<span data-qty-id="${id}" class="editable-quantity">${match}</span>`;
  //     });

  //     return { processedHtml, quantities };
  // };

  const parseHtmlForQuantities = (html) => {
    if (!html) return { processedHtml: "", quantities: [] };

    const quantities = [];
    let processedHtml = html;
    quantityIdCounter.current = 0;

    // 1️⃣ MATCH ANY <span ... data-internal-id="..."> VALUE UNIT </span>
    const internalSpanRegex =
      /<span\b([^>]*?)data-internal-id=['"]([^'"]+)['"]([^>]*)>(\s*\d+\.?\d*)\s*([^<\s]+)[^<]*<\/span>/g;

    processedHtml = processedHtml.replace(
      internalSpanRegex,
      (match, beforeAttr, internalId, afterAttr, value, unit) => {
        const id = `qty_${quantityIdCounter.current++}`;
        const normalizedUnit = unitMapping[unit] || unit.toLowerCase();

        quantities.push({
          id,
          internalId,        // 🔥 finally correct!
          value: parseFloat(value),
          unit: normalizedUnit,
          originalMatch: match,
          isModified: false
        });

        return `<span data-qty-id="${id}" class="editable-quantity">${value} ${unit}</span>`;
      }
    );

    // 2️⃣ FALLBACK FOR PLAIN QUANTITIES (NO internal-id)
    const gujaratiUnits = ["કિગ્રા", "ગ્રામ", "નંગ", "લિટર", "મિલીલીટર"];
    const englishUnits = ["KGS", "Gram", "Pieces", "Liter", "ML", "kgs", "gram", "pieces", "liter", "ml"];
    const allUnits = [...gujaratiUnits, ...englishUnits];
    const quantityPattern = new RegExp(`(\\d+\\.?\\d*)\\s*(${allUnits.join("|")})`, "g");

    processedHtml = processedHtml.replace(quantityPattern, (match, value, unit) => {
      // Skip if this was inside internal-id span (already processed)
      if (match.includes("data-internal-id")) return match;

      const id = `qty_${quantityIdCounter.current++}`;
      const normalizedUnit = unitMapping[unit] || unit.toLowerCase();

      quantities.push({
        id,
        internalId: null,
        value: parseFloat(value),
        unit: normalizedUnit,
        originalMatch: match,
        isModified: false
      });

      return `<span data-qty-id="${id}" class="editable-quantity">${match}</span>`;
    });

    return { processedHtml, quantities };
  };

  // Reconstruct HTML with updated quantities
  const reconstructHtmlWithQuantities = (html, quantities) => {
    if (!html || !quantities.length) return html;

    let reconstructed = html;

    quantities.forEach(({ id, value, unit }) => {
      const unitDisplay = getUnitTypesForPrint(unit)
      // const newValue = `${value} ${unitDisplay}`;
      const displayValue = unit === "pieces" ? Math.round(value) : value;
      const newValue = `${displayValue} ${unitDisplay}`;
      const placeholderPattern = new RegExp(`<span data-qty-id="${id}"[^>]*>.*?</span>`, 'g');
      reconstructed = reconstructed.replace(placeholderPattern, newValue);
    });

    // Ensure base64 logo images are preserved
    // Replace any img tags with alt="Logo" that might have lost their src
    const logoImgPattern = /<img([^>]*alt=["']Logo["'][^>]*)>/gi;
    reconstructed = reconstructed.replace(logoImgPattern, (match, attributes) => {
      // If src is missing or doesn't contain base64, add it
      if (!attributes.includes('src=') || !attributes.includes('base64')) {
        return `<img src="${base64Imagedata}" alt="Logo"${attributes.replace(/alt=["']Logo["']/gi, '')}>`;
      }
      return match;
    });

    return reconstructed;
  };

  // Initialize editable quantities when modal opens
  useEffect(() => {
    if (isOpenPrintPreview && printHtmlContent && editableContentRef.current) {
      const { processedHtml, quantities } = parseHtmlForQuantities(printHtmlContent);

      setEditableQuantities(quantities);
      setPrintHtmlWithPlaceholders(processedHtml);
      editableContentRef.current.innerHTML = processedHtml;

      // Ensure base64 logo images are properly set
      setTimeout(() => {
        const images = editableContentRef.current.querySelectorAll('img[alt="Logo"]');

        images.forEach(img => {

          // Always set the base64 image data to ensure logo displays
          img.src = base64Imagedata;
          img.onerror = () => {
            // Fallback: try setting src again if image fails to load
            img.src = base64Imagedata;
          };
        });
      }, 50);

      // Small delay to ensure DOM is ready
      setTimeout(() => {
        // Replace quantity spans with editable inputs
        quantities.forEach((qty) => {
          const element = editableContentRef.current.querySelector(`[data-qty-id="${qty.id}"]`);
          if (element && !element.dataset.reactInjected) {
            element.dataset.reactInjected = 'true';
            const inputContainer = document.createElement('span');
            inputContainer.className = 'inline-flex items-center gap-1 px-1 mx-1';
            inputContainer.setAttribute('data-qty-id', qty.id);

            const input = document.createElement('input');
            input.type = 'number';
            input.step = '0.001';
            input.value = qty.value;
            input.className = 'w-16 px-1 py-0.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500';
            input.style.minWidth = '60px';
            input.addEventListener('change', (e) => {
              const newValue = parseFloat(e.target.value) || 0;
              setEditableQuantities(prev =>
                prev.map(item => item.id === qty.id ? { ...item, value: newValue, isModified: true } : item)
              );
            });

            const select = document.createElement('select');
            select.className = 'px-1 py-0.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500';
            unitList.forEach(unit => {
              const option = document.createElement('option');
              option.value = unit.key;
              option.textContent = unit.name;
              if (unit.key === qty.unit) option.selected = true;
              select.appendChild(option);
            });
            select.addEventListener('change', (e) => {
              const newUnit = e.target.value;
              setEditableQuantities(prev =>
                prev.map(item => item.id === qty.id ? { ...item, unit: newUnit, isModified: true } : item)
              );
            });

            inputContainer.appendChild(input);
            inputContainer.appendChild(select);
            element.replaceWith(inputContainer);
          }
        });
      }, 100);
    }
    if (!isOpenPrintPreview) {
      setEditableQuantities([]);
      setPrintHtmlWithPlaceholders('');
    }
  }, [isOpenPrintPreview, printHtmlContent]);

  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const [categorySearch, setCategorySearch] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const showPreviousCategory = () => {
    setSelectedCategoryIndex((prev) =>
      prev === 0 ? categoryList?.length - 1 : prev - 1
    );
  };

  const showNextCategory = () => {
    setSelectedCategoryIndex((prev) =>
      prev === categoryList?.length - 1 ? 0 : prev + 1
    );
  };

  // const unitList = [
  //   { key: 'gram', name: 'ગ્રામ (Gram)' },
  //   { key: 'kgs', name: 'કિગ્રા (KGS)' },
  //   { key: 'liter', name: 'લિટર (Liter)' },
  //   { key: 'ml', name: 'મિલીલીટર (ML)' },
  //   { key: 'pieces', name: 'નંગ (Pieces)' },
  //   { key: 'per_person', name: 'માણસો દીઠ (Per Person)' },
  //   { key: 'roll', name: 'રોલ (Roll)' },
  // ];

  const unitList = [
    { key: 'gram', name: 'ગ્રામ' },
    { key: 'kgs', name: 'કિગ્રા' },
    { key: 'liter', name: 'લિટર' },
    { key: 'ml', name: 'મિલીલીટર' },
    { key: 'pieces', name: 'નંગ' },
    { key: 'per_person', name: 'માણસો દીઠ' },
    { key: 'roll', name: 'રોલ' },
  ];


  const [MorningOther, setMorningOther] = useState({
    simpleWaiter: { count: "", price: null, total: null },
    vipWaiter: { count: "", price: null, total: null },
    proWaiter: { count: "", price: null, total: null },
    proCouple: { count: "", price: null, total: null },
    emptyWaiter: { count: "", price: null, total: null },
    // teaCounter: { count: "", price: null, total: null },
    teaCounter: {
      count: "",
      price: null,
      total: null,
      duration: ""      // "full" | "half"
    },
    decoration: { name: "", amount: "" },
    extra: { amount: null },
    labor: { count: "" },
    extraService: { name: "", amount: null },
    counter: { name: "", count: null },
    serviceType: null,

    // Single source of truth
    mode: "default",        // "simple" | "advance" | "default"
    simpleDescription: "",
    simpleAmount: null
  });

  const [AfternoonOther, setAfternoonOther] = useState({
    simpleWaiter: { count: "", price: null, total: null },
    vipWaiter: { count: "", price: null, total: null },
    proWaiter: { count: "", price: null, total: null },
    proCouple: { count: "", price: null, total: null },
    emptyWaiter: { count: "", price: null, total: null },
    // teaCounter: { count: "", price: null, total: null },
    teaCounter: {
      count: "",
      price: null,
      total: null,
      duration: "" // "full" | "half"
    },

    decoration: { name: "", amount: "" },
    extra: { amount: null },
    labor: { count: "" },
    extraService: { name: "", amount: null },
    counter: { name: "", count: null },
    serviceType: null,

    // Single source of truth
    mode: "default",        // "simple" | "advance" | "default"
    simpleDescription: "",
    simpleAmount: null
  });

  const [NightOther, setNightOther] = useState({
    simpleWaiter: { count: "", price: null, total: null },
    vipWaiter: { count: "", price: null, total: null },
    proWaiter: { count: "", price: null, total: null },
    proCouple: { count: "", price: null, total: null },
    emptyWaiter: { count: "", price: null, total: null },
    // teaCounter: { count: "", price: null, total: null },
    teaCounter: {
      count: "",
      price: null,
      total: null,
      duration: "",          // "full" | "half"
    },
    decoration: { name: "", amount: "" },
    extra: { amount: null },
    labor: { count: "" },
    extraService: { name: "", amount: null },
    counter: { name: "", count: null },
    serviceType: null,

    // Single source of truth
    mode: "default",        // "simple" | "advance" | "default"
    simpleDescription: "",
    simpleAmount: null
  });

  const morningContentRef = useRef(null);
  const afternoonContentRef = useRef(null);
  const nightContentRef = useRef(null);

  const [selected, setSelected] = useState({
    option1: false,
    option2: false
  });

  const [categoryCheckboxes, setCategoryCheckboxes] = useState({
    vegetable: false,
    grocery: false,
    dairy: false,
    vasan: false,
    farsan: false
  });

  const handleOptionCheckboxChange = (option) => {
    setSelected((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };

  const handleCategoryCheckboxChange = (category) => {
    setCategoryCheckboxes((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const updateMorningOther = (waiterType, key, value) => {
    setMorningOther((prev) => {
      // ✅ TOP-LEVEL update (checkboxes)
      if (!waiterType) {
        return {
          ...prev,
          [key]: value,
        };
      }

      const updatedWaiter = {
        ...prev[waiterType],
        [key]: value
      };

      if (waiterType !== 'decoration') {
        const count = parseFloat(updatedWaiter.count);
        const price = parseFloat(updatedWaiter.price);

        if (!isNaN(count) && count > 0 && !isNaN(price) && price > 0) {
          updatedWaiter.total = Math.round(count * price);
        } else {
          updatedWaiter.total = 0;
        }
      }
      return { ...prev, [waiterType]: { ...updatedWaiter } };
    });
  };

  const updateAfternoonOther = (waiterType, key, value) => {
    setAfternoonOther((prev) => {
      // ✅ TOP-LEVEL update (checkboxes)
      if (!waiterType) {
        return {
          ...prev,
          [key]: value,
        };
      }

      const updatedWaiter = {
        ...prev[waiterType],
        [key]: value
      };
      if (waiterType !== 'decoration') {
        const count = parseFloat(updatedWaiter.count);
        const price = parseFloat(updatedWaiter.price);

        if (!isNaN(count) && count > 0 && !isNaN(price) && price > 0) {
          updatedWaiter.total = Math.round(count * price);
        } else {
          updatedWaiter.total = 0;
        }
      }

      return { ...prev, [waiterType]: { ...updatedWaiter } };
    });
  };

  const updateNightOther = (waiterType, key, value) => {

    setNightOther((prev) => {

      // ✅ TOP-LEVEL update (checkboxes)
      if (!waiterType) {
        return {
          ...prev,
          [key]: value,
        };
      }

      const updatedWaiter = {
        ...prev[waiterType],
        [key]: value
      };
      if (waiterType !== 'decoration') {
        const count = parseFloat(updatedWaiter.count);
        const price = parseFloat(updatedWaiter.price);

        if (!isNaN(count) && count > 0 && !isNaN(price) && price > 0) {
          updatedWaiter.total = Math.round(count * price);
        } else {
          updatedWaiter.total = 0;
        }
      }
      return { ...prev, [waiterType]: { ...updatedWaiter } };
    });
  };

  const categoryOptionsRef = useRef(null);
  useOutsideClick(categoryOptionsRef, () => {
    setDropdownOpen(false)
    setCategorySearch('');
  });

  const menuOptionsRef = useRef(null);
  useOutsideClick(menuOptionsRef, () => {
    setSearchText('');
    setPopoverOpen(false);

    setDropdownOpen(false);
    setCategorySearch('');
    setSelectedCategoryIndex(0);
  });

  const afternoonRef = useRef(null);
  useOutsideClick(afternoonRef, () => {
    setSearchText('');
    setAfternoonPopoverOpen(false);

    setDropdownOpen(false);
    setCategorySearch('');
    setSelectedCategoryIndex(0);
  });

  const nightRef = useRef(null);
  useOutsideClick(nightRef, () => {
    setSearchText('');
    setNightPopoverOpen(false);

    setDropdownOpen(false);
    setCategorySearch('');
    setSelectedCategoryIndex(0);
  });

  const { mutate: addOrderDetail } = useAddOrderDetails();
  const { mutate: updateOrderDetail } = useUpdateOrderDetails();
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isOpenPrintMaterial, setIsOpenPrintMaterial] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [IsShowMorningDrawer, setIsShowMorningDrawer] = useState(false);
  const [IsShowAfternoonDrawer, setIsShowAfternoonDrawer] = useState(false);
  const [IsShowNightDrawer, setIsShowNightDrawer] = useState(false);

  const getOrderByID = async () => {
    const order = await getOrderbyId(selectedOrder._id);
    setselectedOrder(order.data.data);
  }

  // Helper: compute misc total and display unit based on persons and unit conversions
  const computeMiscTotal = (item, persons) => {
    const qty = Number(item?.quantity) || 0;
    const baseFor = Number(item?.baseQuantityFor) || 1;

    let total = (String(item?.baseQuantityUnit || '').toLowerCase() === 'person')
      ? (qty / baseFor) * (Number(persons) || 0)
      : qty;

    let unit = item?.unit || '';
    const convMap = {
      gram: { threshold: 1000, newUnit: 'kgs', factor: 1000 },
      gm: { threshold: 1000, newUnit: 'kgs', factor: 1000 },
      ml: { threshold: 1000, newUnit: 'liter', factor: 1000 },
    };
    const key = String(unit).toLowerCase();
    const conv = convMap[key];
    if (conv && total >= conv.threshold) {
      total = total / conv.factor;
      unit = conv.newUnit;
    }
    return { total, unit };
  };

  // After calculation, persist computed total/unit into morningMisc array
  useEffect(() => {
    setMorningMisc((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      let changed = false;
      const persons = Number(inputValue?.mTotalPerson) || 0;
      const next = prev.map((m) => {
        const hasTotal = m?.total != null && m?.total !== '';
        const hasUnit = m?.totalUnit != null && m?.totalUnit !== '';
        // if (hasTotal && hasUnit) return m;
        const person = persons > 0 ? persons : m.baseQuantityFor;
        const { total, unit } = computeMiscTotal(m, person);
        const updated = {
          ...m,
          total: total,
          totalUnit: (unit || m?.unit || ''),
          // total: hasTotal ? m.total : total,
          // totalUnit: hasUnit ? m.totalUnit : (unit || m?.unit || ''),
        };
        changed = true;
        // if (updated.total !== m.total || updated.totalUnit !== m.totalUnit) changed = true;
        return updated;
      });
      return changed ? next : prev;
    });
  }, [inputValue?.mTotalPerson, morningMisc?.length]);

  // After calculation, persist computed total/unit into afternoonMisc array
  useEffect(() => {
    setAfternoonMisc((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      let changed = false;
      const persons = Number(inputValue?.aTotalPerson) || 0;
      const next = prev.map((m) => {
        const hasTotal = m?.total != null && m?.total !== '';
        const hasUnit = m?.totalUnit != null && m?.totalUnit !== '';
        // if (hasTotal && hasUnit) return m;
        const person = persons > 0 ? persons : m.baseQuantityFor;
        const { total, unit } = computeMiscTotal(m, person);
        const updated = {
          ...m,
          total: total,
          totalUnit: (unit || m?.unit || ''),
          // total: hasTotal ? m.total : total,
          // totalUnit: hasUnit ? m.totalUnit : (unit || m?.unit || ''),
        };
        changed = true;
        // if (updated.total !== m.total || updated.totalUnit !== m.totalUnit) changed = true;
        return updated;
      });
      return changed ? next : prev;
    });
  }, [inputValue?.aTotalPerson, afternoonMisc?.length]);

  // After calculation, persist computed total/unit into nightMisc array
  useEffect(() => {
    setNightMisc((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      let changed = false;
      const persons = Number(inputValue?.nTotalPerson) || 0;
      const next = prev.map((m) => {
        const hasTotal = m?.total != null && m?.total !== '';
        const hasUnit = m?.totalUnit != null && m?.totalUnit !== '';
        // if (hasTotal && hasUnit) return m;
        const person = persons > 0 ? persons : m.baseQuantityFor;
        const { total, unit } = computeMiscTotal(m, person);
        const updated = {
          ...m,
          total: total,
          totalUnit: (unit || m?.unit || ''),
          // total: hasTotal ? m.total : total,
          // totalUnit: hasUnit ? m.totalUnit : (unit || m?.unit || ''),
        };
        changed = true;
        // if (updated.total !== m.total || updated.totalUnit !== m.totalUnit) changed = true;
        return updated;
      });
      return changed ? next : prev;
    });
  }, [inputValue?.nTotalPerson, nightMisc?.length]);

  useEffect(() => {
    if (selectedOrder) {
      const orderDetails = selectedOrder.OrderDetails;

      const defaultSelectedMisc = allMiscellaneousItems?.filter((item) => item.isDefaultSelected === true)
        .map((m) => {
          const { total, unit } = computeMiscTotal(m, m.baseQuantityFor);
          return {
            ...m,
            total: total,
            totalUnit: unit,
          };
        });



      if (orderDetails && orderDetails.length > 0) {
        const orderDetail = orderDetails[0];
        setIsEdit(true);
        setOrderDetailsId(orderDetail._id);

        setInputValue({
          mPrice: orderDetail.mPrice || '',
          mTotalPerson: orderDetail.mTotalPerson || '',
          mTotal: orderDetail.mTotal || 0,
          aPrice: orderDetail.aPrice || '',
          aTotalPerson: orderDetail.aTotalPerson || '',
          aTotal: orderDetail.aTotal || 0,
          nPrice: orderDetail.nPrice || '',
          nTotalPerson: orderDetail.nTotalPerson || '',
          nTotal: orderDetail.nTotal || 0,
          bName: orderDetail.bName || '',
          bPrice: orderDetail.bPrice || '',
          bTotalPerson: orderDetail.bTotalPerson || '',
          bTotal: orderDetail.bTotal || 0,
          totalAmount: orderDetail.totalAmount || 0,
          paidByClient: orderDetail.paidByClient || 0,
          dueamount: orderDetail.dueAmount || 0,
        });

        if (orderDetail.morningMenu && menuLists) {
          const detailedMorningMenu = orderDetail.morningMenu.map((menuId) =>
            menuLists && menuLists.find((item) => item._id === menuId)
          ).filter(Boolean);
          setMorningOptions(detailedMorningMenu);
        }

        if (orderDetail.afternoonMenu && menuLists) {
          const detailedafternoonMenu = orderDetail.afternoonMenu.map((menuId) =>
            menuLists && menuLists.find((item) => item._id === menuId)
          ).filter(Boolean);
          setAfternoonSelectedOptions(detailedafternoonMenu);
        }

        if (orderDetail.nightMenu && menuLists) {
          const detailednightMenu = orderDetail.nightMenu.map((menuId) =>
            menuLists && menuLists.find((item) => item._id === menuId)
          ).filter(Boolean);

          setNightSelectedOptions(detailednightMenu);
        }

        if (orderDetail.morningmiscellaneous && orderDetail.morningmiscellaneous.length > 0 && allMiscellaneousItems) {
          const persons = Number(inputValue?.mTotalPerson || orderDetail?.mTotalPerson) || 0;
          const detailedMorningMisc = orderDetail.morningmiscellaneous
            .map((miscId) => {
              const base = allMiscellaneousItems && allMiscellaneousItems.find((item) => item._id === miscId._id);
              if (!base) return null;
              const merged = { ...base };
              const hasTotal = miscId?.total != null && miscId?.total !== '';
              const hasUnit = miscId?.totalUnit != null && miscId?.totalUnit !== '';
              if (hasTotal) merged.total = miscId.total;
              if (hasUnit) merged.totalUnit = miscId.totalUnit;
              if (!hasTotal || !hasUnit) {
                const { total, unit } = computeMiscTotal(merged, persons);
                if (!hasTotal) merged.total = total;
                if (!hasUnit) merged.totalUnit = unit || merged.unit || '';
              }
              return merged;
            })
            .filter(Boolean);
          setMorningMisc(detailedMorningMisc);
        } else {
          setMorningMisc(defaultSelectedMisc);
        }

        if (orderDetail.afternoonmiscellaneous && orderDetail.afternoonmiscellaneous.length > 0 && allMiscellaneousItems) {
          const persons = Number(inputValue?.aTotalPerson || orderDetail?.aTotalPerson) || 0;
          const detailedAfternoonMisc = orderDetail.afternoonmiscellaneous
            .map((miscId) => {
              const base = allMiscellaneousItems && allMiscellaneousItems.find((item) => item._id === miscId._id);
              if (!base) return null;
              const merged = { ...base };
              const hasTotal = miscId?.total != null && miscId?.total !== '';
              const hasUnit = miscId?.totalUnit != null && miscId?.totalUnit !== '';
              if (hasTotal) merged.total = miscId.total;
              if (hasUnit) merged.totalUnit = miscId.totalUnit;
              if (!hasTotal || !hasUnit) {
                const { total, unit } = computeMiscTotal(merged, persons);
                if (!hasTotal) merged.total = total;
                if (!hasUnit) merged.totalUnit = unit || merged.unit || '';
              }
              return merged;
            })
            .filter(Boolean);
          setAfternoonMisc(detailedAfternoonMisc);
        } else {
          setAfternoonMisc(defaultSelectedMisc);
        }

        if (orderDetail.nightmiscellaneous && orderDetail.nightmiscellaneous.length > 0 && allMiscellaneousItems) {
          const persons = Number(inputValue?.nTotalPerson || orderDetail?.nTotalPerson) || 0;
          const detailedNightMisc = orderDetail.nightmiscellaneous
            .map((miscId) => {
              const base = allMiscellaneousItems && allMiscellaneousItems.find((item) => item._id === miscId._id);
              if (!base) return null;
              const merged = { ...base };
              const hasTotal = miscId?.total != null && miscId?.total !== '';
              const hasUnit = miscId?.totalUnit != null && miscId?.totalUnit !== '';
              if (hasTotal) merged.total = miscId.total;
              if (hasUnit) merged.totalUnit = miscId.totalUnit;
              if (!hasTotal || !hasUnit) {
                const { total, unit } = computeMiscTotal(merged, persons);
                if (!hasTotal) merged.total = total;
                if (!hasUnit) merged.totalUnit = unit || merged.unit || '';
              }
              return merged;
            })
            .filter(Boolean);
          setNightMisc(detailedNightMisc);
        } else {
          setNightMisc(defaultSelectedMisc);
        }

        if (orderDetail?.morningOther) {
          // setMorningOther(orderDetail.morningOther);
          setMorningOther({
            ...orderDetail.morningOther,
            mode: orderDetail.morningOther?.mode || "advanced",
            simpleDescription: orderDetail.morningOther?.simpleDescription || "",
            simpleAmount: orderDetail.morningOther?.simpleAmount || null,
          });
          calcMorning()
        }

        if (orderDetail?.afternoonOther) {
          // setAfternoonOther(orderDetail.afternoonOther);
          setAfternoonOther({
            ...orderDetail.afternoonOther,
            mode: orderDetail.afternoonOther?.mode || "advanced",
            simpleDescription: orderDetail.afternoonOther?.simpleDescription || "",
            simpleAmount: orderDetail.afternoonOther?.simpleAmount || null,

          });
          calcAfternoon();
        }

        if (orderDetail.nightOther) {
          // setNightOther(orderDetail.nightOther);
          setNightOther({
            ...orderDetail.nightOther,
            mode: orderDetail.nightOther?.mode || "advanced",
            simpleDescription: orderDetail.nightOther?.simpleDescription || "",
            simpleAmount: orderDetail.nightOther?.simpleAmount || null,

          });
          calcNight();
        }

        // Load meal types
        if (orderDetail.morningMealType) {
          setMorningMealType(orderDetail.morningMealType);
        }
        if (orderDetail.afternoonMealType) {
          setAfternoonMealType(orderDetail.afternoonMealType);
        }
        if (orderDetail.nightMealType) {
          setNightMealType(orderDetail.nightMealType);
        }
      } else {
        setMorningMisc(defaultSelectedMisc);
        setAfternoonMisc(defaultSelectedMisc);
        setNightMisc(defaultSelectedMisc);
        // Reset meal types for new order
        setMorningMealType('');
        setAfternoonMealType('');
        setNightMealType('');
      }
    }
  }, [selectedOrder, menuLists]);

  useEffect(() => {
    if (Object.keys(MorningOther).length > 0) {
      calcMorning();
    }
  }, [MorningOther]);

  useEffect(() => {
    if (Object.keys(AfternoonOther).length > 0) {
      calcAfternoon();
    }
  }, [AfternoonOther]);

  useEffect(() => {
    if (Object.keys(NightOther).length > 0) {
      calcNight();
    }
  }, [NightOther]);

  const togglePopover = () => {
    setSearchText('');
    setPopoverOpen(!isPopoverOpen);
  };

  const togglePopoverAfternoon = () => {
    setSearchText('');
    setAfternoonPopoverOpen(!isAfternoonPopoverOpen);
  };

  const togglePopoverNight = () => {
    setSearchText('');
    setNightPopoverOpen(!isNightPopoverOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only numbers and decimal point for numeric fields
    const numericFields = ['mPrice', 'mTotalPerson', 'aPrice', 'aTotalPerson', 'nPrice', 'nTotalPerson', 'bPrice', 'bTotalPerson', 'paidByClient'];

    if (numericFields.includes(name)) {
      // Allow only numbers, decimal point, and empty string
      const numericValue = value.replace(/[^0-9.]/g, '');

      // Prevent multiple decimal points
      const parts = numericValue.split('.');
      const finalValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : numericValue;

      setInputValue({
        ...inputValue,
        [name]: finalValue,
      });
    } else {
      setInputValue({
        ...inputValue,
        [name]: value.toString(),
      });
    }

    setError({ ...Error, partyName: "", farmName: true });
  };

  // Add a new function for handling waiter and service input changes
  const handleNumericChange = (e) => {
    const { value } = e.target;

    // Allow only numbers and decimal point
    const numericValue = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimal points
    const parts = numericValue.split('.');
    const finalValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : numericValue;

    return finalValue;
  };

  const hasAnyOtherValue = (data) => {
    return (
      Number(data.simpleWaiter?.count) > 0 ||
      Number(data.vipWaiter?.count) > 0 ||
      Number(data.proWaiter?.count) > 0 ||
      Number(data.proCouple?.count) > 0 ||
      Number(data.emptyWaiter?.count) > 0 ||
      Number(data.teaCounter?.count) > 0 ||
      Number(data.labor?.count) > 0 ||
      Number(data.counter?.count) > 0 ||
      Number(data.extra?.amount) > 0 ||
      Number(data.extraService?.amount) > 0 ||
      (data.decoration?.name && data.decoration?.amount)
    );
  };

  const scrollToCard = (ref, setOpen) => {
    setOpen(true);
    setTimeout(() => {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const validateTeaCounter = (other, ref, setDrawer) => {
    if (
      Number(other?.teaCounter?.count) > 0 &&
      !other?.teaCounter?.duration
    ) {
      showErrorToast(t("Please select duration for tea counter"));
      scrollToCard(ref, setDrawer);
      return true;
    }
    return false;
  };

  const ensureTeaCounterType = (other) => {
    if (other?.teaCounter && !("duration" in other.teaCounter)) {
      other.teaCounter.duration = ""; // default value
    }
  };

  const onSubmit = () => {
    // Validation for morning meal type
    if (inputValue.mTotalPerson && inputValue.mPrice && !morningMealType) {
      showErrorToast(t('Please select morning meal type'));
      return;
    }

    // Validation for afternoon meal type
    if (inputValue.aTotalPerson && inputValue.aPrice && !afternoonMealType) {
      showErrorToast(t('Please select afternoon meal type'));
      return;
    }

    // Validation for night meal type
    if (inputValue.nTotalPerson && inputValue.nPrice && !nightMealType) {
      showErrorToast(t('Please select night meal type'));
      return;
    }

    if (hasAnyOtherValue(MorningOther) && !MorningOther.serviceType) {
      showErrorToast(t("Please select service type for morning"));
      scrollToCard(morningContentRef, setIsShowMorningDrawer);
      return;
    }

    if (hasAnyOtherValue(AfternoonOther) && !AfternoonOther.serviceType) {
      showErrorToast(t("Please select service type for afternoon"));
      scrollToCard(afternoonContentRef, setIsShowAfternoonDrawer);
      return;
    }

    if (hasAnyOtherValue(NightOther) && !NightOther.serviceType) {
      showErrorToast(t("Please select service type for night"));
      scrollToCard(nightContentRef, setIsShowNightDrawer);
      return;
    }

    // tea counter
    if (validateTeaCounter(MorningOther, morningContentRef, setIsShowMorningDrawer)) return;
    if (validateTeaCounter(AfternoonOther, afternoonContentRef, setIsShowAfternoonDrawer)) return;
    if (validateTeaCounter(NightOther, nightContentRef, setIsShowNightDrawer)) return;

    ensureTeaCounterType(MorningOther);
    ensureTeaCounterType(AfternoonOther);
    ensureTeaCounterType(NightOther);

    setIsLoading(true);
    const orderDetailData = {
      ...inputValue,
      orderId: selectedOrder._id,
      morningOptions: morningOptions,
      afternoonselectedOptions: afternoonselectedOptions,
      nightSelectedOptions: nightSelectedOptions,
      morningOther: MorningOther,
      afternoonOther: AfternoonOther,
      nightOther: NightOther,
      morningmiscellaneous: inputValue.mTotalPerson ? morningMisc : [],
      afternoonmiscellaneous: inputValue.aTotalPerson ? afternoonMisc : [],
      nightmiscellaneous: inputValue.nTotalPerson ? nightMisc : [],
      morningMealType: morningMealType,
      afternoonMealType: afternoonMealType,
      nightMealType: nightMealType
    };

    if (isEdit) {
      orderDetailData._id = orderDetailsId;
      updateOrderDetail(orderDetailData, {
        onSuccess: (res) => {
          setIsLoading(false);
          showSuccessToast(res?.data?.message);
          setError({ ...Error, name: '' });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    } else {
      addOrderDetail(orderDetailData, {
        onSuccess: (res) => {
          setIsLoading(false);
          showSuccessToast(res?.data?.message);
          getOrderByID();
          setError({ ...Error, name: '' });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    }
  }

  const calcMorning = () => {
    if (inputValue.mPrice && inputValue.mTotalPerson) {

      // const morningOtherTotal = Object.values(MorningOther || {}).reduce((acc, waiter) => {
      //     return acc + Number(waiter.total || 0);
      // }, 0);

      // 🛑 SIMPLE MODE → no extra calculation
      if (!MorningOther.mode || MorningOther.mode === "simple") {
        const simpleAmount = Number(MorningOther.simpleAmount || 0);
        setInputValue(prevState => {
          const updatedState = {
            ...prevState,
            mTotal: (prevState.mPrice * prevState.mTotalPerson) + simpleAmount
          };
          calcGrandTotal(updatedState);
          return updatedState;
        });
        return;
      }

      const morningOtherTotal = Object.entries(MorningOther || {}).reduce((acc, [key, value]) => {
        if (key === "decoration" || key === 'extra' || key === 'extraService') {
          return acc + Number(value.amount || 0);
        }
        // Skip labor count as it's not a monetary value
        if (key === 'labor' || key == 'serviceType') {
          return acc;
        }
        return acc + Number(value?.total || 0);
      }, 0);

      setInputValue((prevState) => {
        const updatedState = {
          ...prevState,
          mTotal: (prevState.mPrice * prevState.mTotalPerson) + morningOtherTotal,
        };
        calcGrandTotal(updatedState);
        return updatedState;
      });
    }
  };

  const calcAfternoon = () => {
    if (inputValue.aPrice && inputValue.aTotalPerson) {

      // const afternoonOtherTotal = Object.values(AfternoonOther || {}).reduce((acc, waiter) => {
      //     return acc + Number(waiter.total || 0);
      // }, 0);

      // 🛑 SIMPLE MODE → no extras
      if (!AfternoonOther.mode || AfternoonOther.mode === "simple") {
        const simpleAmount = Number(AfternoonOther?.simpleAmount || 0);
        setInputValue(prev => {
          const updated = {
            ...prev,
            aTotal: (prev.aPrice * prev.aTotalPerson) + simpleAmount
          };
          calcGrandTotal(updated);
          return updated;
        });
        return;
      }

      const afternoonOtherTotal = Object.entries(AfternoonOther || {}).reduce((acc, [key, value]) => {
        if (key === "decoration" || key === 'extra' || key === 'extraService') {
          return acc + Number(value.amount || 0);
        }
        // Skip labor count as it's not a monetary value
        if (key === 'labor' || key == 'serviceType') {
          return acc;
        }
        return acc + Number(value?.total || 0);
      }, 0);

      setInputValue((prevState) => {
        const updatedState = {
          ...prevState,
          aTotal: (prevState.aPrice * prevState.aTotalPerson) + afternoonOtherTotal,
        };
        calcGrandTotal(updatedState);
        return updatedState;
      });
    }
  };

  const calcNight = () => {
    if (inputValue.nPrice && inputValue.nTotalPerson) {

      // const NightOtherTotal = Object.values(NightOther || {}).reduce((acc, waiter) => {
      //     return acc + Number(waiter.total || 0);
      // }, 0);

      // 🛑 SIMPLE MODE → no extras
      if (!NightOther.mode || NightOther.mode === "simple") {
        const simpleAmount = Number(NightOther.simpleAmount || 0);
        setInputValue(prev => {
          const updated = {
            ...prev,
            nTotal: (prev.nPrice * prev.nTotalPerson) + simpleAmount
          };
          calcGrandTotal(updated);
          return updated;
        });
        return;
      }

      const NightOtherTotal = Object.entries(NightOther || {}).reduce((acc, [key, value]) => {
        if (key === "decoration" || key === 'extra' || key === 'extraService') {
          return acc + Number(value.amount || 0);
        }
        // Skip labor count as it's not a monetary value
        if (key === 'labor' || key == 'serviceType') {
          return acc;
        }
        return acc + Number(value?.total || 0);
      }, 0);

      setInputValue((prevState) => {
        const updatedState = {
          ...prevState,
          nTotal: (prevState.nPrice * prevState.nTotalPerson) + NightOtherTotal,
        };
        calcGrandTotal(updatedState);
        return updatedState;
      });
    }
  };

  const calcBreakfast = () => {
    if (inputValue.bPrice && inputValue.bTotalPerson) {
      setInputValue((prevState) => {
        const updatedState = {
          ...prevState,
          bTotal: (prevState.bPrice * prevState.bTotalPerson),
        };
        calcGrandTotal(updatedState);
        return updatedState;
      });
    }
  };

  const calcGrandTotal = (updatedState) => {
    const { mTotal, aTotal, nTotal, bTotal } = updatedState;
    const totalAmount =
      (mTotal || 0) +
      (aTotal || 0) +
      (nTotal || 0) +
      (bTotal || 0);

    setInputValue((prevState) => ({
      ...prevState,
      totalAmount: totalAmount,
    }));

    if (inputValue.paidByClient) {
      setInputValue((prevState) => ({
        ...prevState,
        dueamount: totalAmount - inputValue.paidByClient
      }));
    } else {
      setInputValue((prevState) => ({
        ...prevState,
        dueamount: totalAmount
      }));
    }
  };

  const calcDueamount = (value) => {
    if (inputValue.totalAmount) {
      const val = value || 0;
      setInputValue((prevState) => ({
        ...prevState,
        dueamount: inputValue.totalAmount - val
      }));
    }
  }

  const handleCheckboxChange = (option) => {
    setMorningOptions((prevState) => {
      const exists = prevState.some((item) => item._id === option._id);

      let updatedList;

      if (exists) {
        updatedList = prevState.filter((item) => item._id !== option._id);
      } else {
        updatedList = [...prevState, option];
      }

      // ✅ Sort by category.sortOrder
      return updatedList.sort(
        (a, b) =>
          (a?.category?.sortOrder || 0) - (b?.category?.sortOrder || 0)
      );
    });
  };

  const removeMenuItem = (itemToRemove) => {
    setMorningOptions((prev) => prev.filter(item => item !== itemToRemove));
  };

  const handleCheckboxChangeForAfternoon = (option) => {
    setAfternoonSelectedOptions((prevState) => {
      const exists = prevState.some((item) => item._id === option._id);

      let updatedList;

      if (exists) {
        updatedList = prevState.filter((item) => item._id !== option._id);
      } else {
        updatedList = [...prevState, option];
      }

      // ✅ Sort by category sortOrder
      return updatedList.sort(
        (a, b) =>
          (a?.category?.sortOrder || 0) - (b?.category?.sortOrder || 0)
      );
    });
  };

  const removeMenuItemForAfternoon = (itemToRemove) => {
    setAfternoonSelectedOptions((prev) => prev.filter(item => item !== itemToRemove));
  };

  const handleCheckboxChangeForNight = (option) => {
    setNightSelectedOptions((prevState) => {
      const exists = prevState.some((item) => item._id === option._id);

      let updatedList;

      if (exists) {
        updatedList = prevState.filter((item) => item._id !== option._id);
      } else {
        updatedList = [...prevState, option];
      }

      // ✅ Sort by category.sortOrder
      return updatedList.sort(
        (a, b) =>
          (a?.category?.sortOrder || 0) - (b?.category?.sortOrder || 0)
      );
    });
  };

  const removeMenuItemForNight = (itemToRemove) => {
    setNightSelectedOptions((prev) => prev.filter(item => item !== itemToRemove));
  };

  const filteredMenuLists =
    menuLists?.filter((option) => {
      const name = option?.menuName || "";
      const nameEn = option?.menuNameEn || "";
      const query = searchText.toLowerCase().trim();

      const selectedCategoryId = categoryList[selectedCategoryIndex]?._id;

      const matchesSearch =
        name.toLowerCase().includes(query) ||
        nameEn.toLowerCase().includes(query);

      const matchesCategory =
        selectedCategoryId === "all" || option.category._id === selectedCategoryId;

      return matchesSearch && matchesCategory;
    }) || [];


  const generateOtherFieldsHtml = (otherData, mealType) => {

    const { simpleWaiter, vipWaiter, proWaiter, emptyWaiter, proCouple, teaCounter, decoration, extra, labor, extraService, counter, serviceType, mode, simpleDescription, simpleAmount } = otherData;

    // default for old data
    const finalMode = mode || "simple";
    const serviceTypeHtml = serviceType
      ? `<div style="text-align:center;padding-bottom:5px;font-weight:semibold; font-size:20px;"> 
         ${serviceType === "extra" ? t("is_extra") : t("is_included")}
      </div>`
      : "";

    if (finalMode === "simple") {
      if (!simpleDescription) return "";

      return `
        <div style="font-weight:600; font-size:20px; padding-bottom:6px;text-align:center; color:#C6A75E;">
          ${translateMealType(mealType)}
        </div>
        <div style="border: 1px solid #e0e0e0; padding: 10px 16px;border-radius: 8px;height: fit-content;">
        ${serviceTypeHtml}
        <div style="padding:10px;font-size:14px; white-space: pre-line; border:1px solid;">
          ${simpleDescription.replace(/\n/g, "<br>")}
        </div>
        </div>
    `;
    }
    // Names you want to allow
    const allowedFields = [
      t('Simple_waiter'),
      t('VIP_waiter'),
      t('PRO_waiter'),
      t('PRO_couple'),
      t('Empty_waiter'),
      t('Tea_Counter'),
    ];

    const otherFields = [
      { name: t('counter'), value: counter?.count ?? '', nameVal: counter?.name || "" },
      { name: t('Simple_waiter'), value: simpleWaiter.count },
      { name: t('VIP_waiter'), value: vipWaiter.count },
      { name: t('PRO_waiter'), value: proWaiter.count },
      { name: t('PRO_couple'), value: proCouple?.count || 0 },
      { name: t('Empty_waiter'), value: emptyWaiter.count },
      { name: t('Tea_Counter'), value: teaCounter.count, duration: teaCounter?.duration || "" },
      { name: t('labor'), value: labor?.count, hideInModes: ['default'] },
      { name: t('decoration'), value: decoration?.amount, onlyShowName: true, nameVal: decoration?.name || "" },
      { name: 'Extra', value: extra?.amount, onlyShowName: true, hideInModes: ['default'] },
      { name: extraService?.name || t('Extra_Service'), value: extraService?.amount, onlyShowName: true, displayName: extraService?.name, hideInModes: ['default'] }
    ];

    const validFields = otherFields.filter(
      field =>
        field.value !== "" &&
        field.value !== null &&
        field.value !== undefined &&
        field.value !== 0 &&
        field.value !== "0"
    );

    // Even if some have empty values (like decoration, extra), we still want them shown
    if (finalMode !== "default" && validFields.length === 0) return "";

    if (finalMode === "default") {

      const visibleFields = validFields.filter(
        field => !field.hideInModes?.includes(finalMode)
      );

      const extraDetailsHtml = `
      <div style="margin-top:12px;">
        <div style="
          font-size:18px;
          font-weight:600;
          margin-bottom:4px;
          color: #333333;
        ">
          ${t('Extra_details')}
        </div>

        <div style="
          /* width:100%; */
          height:auto;
          min-height:120px;
          border:1px solid #333333;
          border-radius:4px;
          padding:10px;
        ">
        ${simpleDescription}
        </div>
      </div>
    `;

      const checkboxInputRows = visibleFields
        .filter(field => allowedFields.includes(field.name)) // safety
        .map(field => `
        <div style="
          display:flex;
          align-items:center;
          padding:4px 3px;
          font-size:14px;
        ">
          <!-- Manual Input Box -->
          <div style="
            /* height:22px; */
            margin-right:8px;
            width:15%;
            text-align:center;
            font-weight:600;
           /* border:1px solid black; */
          ">
          ${field.value}
          </div>

          <!-- Service Name -->
          <div style="
            flex:1;
            font-weight:600;
            color:#333333;
          ">
            ${field.name} 
            ${field?.duration
            ? ` <span style="
                font-weight:500;
                font-size:12px;
                margin-left:6px;
                color:#000000;
              ">
              (${field?.duration === "half" ? t("Bapor_To_Ratre") : t("Full_Day")})
            </span>`
            : ""}
          </div>

        
        </div>
      `)
        .join("");

      return ` 
        <div style="font-weight: 600; font-size: 20px;text-align:center; padding-bottom:6px;text-transform: capitalize;color:#C6A75E;">
           ${translateMealType(mealType)}
        </div>
        <div style="border: 1px solid #e0e0e0; padding: 10px 16px;border-radius: 8px;height: fit-content;">
        ${serviceTypeHtml}
        <div style="margin-top:6px;">
          ${checkboxInputRows}
        </div>
        ${extraDetailsHtml}
        </div>
      `;
    }
    // ✅ Add serviceType heading

    return `
        <div style="font-weight:600; font-size: 20px;text-align:center; padding-bottom:6px;text-transform: capitalize; color:#C6A75E;">
           ${translateMealType(mealType)}
        </div>
        <div style="border: 1px solid #e0e0e0; padding: 10px 16px;border-radius: 8px;height: fit-content;">
        ${serviceTypeHtml}
        <table style="width: 100%; border-collapse: collapse; margin: 0px 0;">
            <thead>
                <tr>
                    <th style="width: 25%; color: #333; padding: 4px 6px; font-weight:600; font-size: 14px; border: 1px solid #333;">Service Type</th>
                    <th style="width: 25%; color: #333; padding: 4px 6px; font-weight:600; font-size: 14px; border: 1px solid #333;">Details</th>
                    <th style="width: 50%; color: #333; padding: 4px 6px; font-weight: 500; font-size: 14px; border: 1px solid #333;"></th>
                </tr>
            </thead>
            <tbody>
              ${validFields
        .map((field, index) => {
          // ✅ Replace newlines with <br> for multiline display
          const formattedNameVal = field?.nameVal
            ? field.nameVal.replace(/\n/g, "<br>")
            : "";



          return `
                                  <tr>
                                      <td style="width: 25%; color: #333; padding: 4px 6px; font-weight: 600; font-size: 13px; border: 1px solid #333; vertical-align: top;">
                                          ${field.name} 
                                      </td>
                                      <td style="width: 25%; color: #333; padding: 4px 6px; font-size: 13px; border: 1px solid #333; vertical-align: top;">
                                          ${field?.onlyShowName ? '' : field.value}
                                      </td>
                                      <td style="
                                          width: 50%;
                                          color: #333;
                                          font-size: 13px;
                                          border-top: none;
                                          padding: 4px 6px;
                                          border-left: none;
                                        
                                          border-right: 1px solid #333;
                                          ${index === validFields.length - 1 ? 'border-bottom: 1px solid #333;' : 'border-bottom: none;'}
                                          vertical-align: top;
                                      ">
                                          ${formattedNameVal}
                                          ${field?.duration
                                          ? ` <span style="
                                                font-weight:500;
                                                font-size:11px;
                                                margin-left:6px;
                                                color:#666;
                                              ">
                                              (${field?.duration === "half" ? t("Bapor_To_Ratre") : t("Full_Day")})
                                            </span>`
                                          : ""}
                                      </td>
                                  </tr>
                              `;
        })
        .join("")}
            </tbody>
        </table>
        </div>
    `;
  };

  const numToCode = (num) => {
    // Check for null, undefined, or empty
    if (num === null || num === undefined || num === '' || num == 0) {
      return '';
    }

    return String(num)
      .split('')
      .map(digit => codeNumberMap[digit] || '')
      .join('');
  };

  // const handlePrint = () => {

  //   if (morningOptions.length === 0 && afternoonselectedOptions.length === 0 && nightSelectedOptions.length === 0) {
  //     showErrorToast(t('Menu_Print_Er'));
  //     return;
  //   }

  //   if (selectedOrder) {
  //     const { partyName, farm, contactNumber, eventDate } = selectedOrder;

  //     const {
  //       mTotalPerson,
  //       aTotalPerson,
  //       nTotalPerson,
  //     } = inputValue;

  //     const morningAmountCode = numToCode(inputValue.mPrice);
  //     const afternoonAmountCode = numToCode(inputValue.aPrice);
  //     const nightAmountCode = numToCode(inputValue.nPrice);

  //     if (morningOptions || afternoonselectedOptions || nightSelectedOptions) {

  //       // Morning HTML
  //       // ✅ sort by category.sortOrder first
  //       const groupedOptions = morningOptions
  //         .sort(
  //           (a, b) =>
  //             (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
  //         )
  //         .reduce((groups, option) => {
  //           const categoryKey =
  //             option?.category?.categoryName || "Unknown_Category";

  //           if (!groups[categoryKey]) {
  //             groups[categoryKey] = [];
  //           }

  //           groups[categoryKey].push(option);
  //           return groups;
  //         }, {});

  //       let MorningHtml = '';
  //       let MorningOtherHtml = '';
  //       let index = 0;
  //       for (const categoryName in groupedOptions) {
  //         const categoryItems = groupedOptions[categoryName];

  //         const categoryBgColor = (index % 2 === 0) ? '#4f726c' : '#14312c';
  //         const menuBgColor = (index % 2 === 0) ? '#14312c' : '#4f726c';

  //         index++;
  //         MorningHtml += `
  //                       <tr>
  //                           <td 
  //                               class="category-column-a" 
  //                               style="
  //                                   width: 20%; 
  //                                   background-color: #f8f9fa; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-weight: bold;
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
  //                           </td>
  //                           <td 
  //                               class="menu-column-a" 
  //                               style="
  //                                   width: 80%; 
  //                                   background-color: #ffffff; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
  //                           </td>
  //                       </tr>
  //                   `;
  //         // MorningHtml += `
  //         //     <h3 style="margin: 0px;font-weight: 600;text-align: start;">${categoryName === 'Unknown_Category' ? 'Other' : categoryName} (${categoryItems.length})</h3>
  //         //     <div class="vdetails">
  //         //         ${categoryItems.map((option, index) => `
  //         //             <div class="vdetail-row">
  //         //                 <span class="vd-label">${index + 1}</span>
  //         //                 <span class="vd-value">${option.menuName}</span>
  //         //             </div>
  //         //         `).join("")}
  //         //     </div>
  //         // `;
  //       }

  //       MorningOtherHtml += generateOtherFieldsHtml(MorningOther, morningMealType);

  //       //Afternoon HTML
  //       // ✅ sort by category.sortOrder first
  //       const groupedOptionsForAfternoon = afternoonselectedOptions
  //         .sort(
  //           (a, b) =>
  //             (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
  //         )
  //         .reduce((groups, option) => {
  //           const categoryKey =
  //             option?.category?.categoryName || "Unknown_Category";

  //           if (!groups[categoryKey]) {
  //             groups[categoryKey] = [];
  //           }

  //           groups[categoryKey].push(option);
  //           return groups;
  //         }, {});

  //       let afternoonHtml = '';
  //       let afternoonOtherHtml = '';
  //       let afternoonIndex = 0;
  //       for (const categoryName in groupedOptionsForAfternoon) {
  //         const categoryItems = groupedOptionsForAfternoon[categoryName];

  //         const categoryBgColor = (afternoonIndex % 2 === 0) ? '#4f726c' : '#14312c';
  //         const menuBgColor = (afternoonIndex % 2 === 0) ? '#14312c' : '#4f726c';

  //         afternoonIndex++;
  //         afternoonHtml += `
  //                       <tr>
  //                           <td 
  //                               class="category-column-a" 
  //                               style="
  //                                   width: 20%; 
  //                                   background-color: #f8f9fa; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-weight: bold;
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
  //                           </td>
  //                           <td 
  //                               class="menu-column-a" 
  //                               style="
  //                                   width: 80%; 
  //                                   background-color: #ffffff; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
  //                           </td>
  //                       </tr>
  //                   `;

  //         // afternoonHtml += `
  //         //      <h3 style="margin: 0px;font-weight: 600;text-align: start;">${categoryName === 'Unknown_Category' ? 'Other' : categoryName} (${categoryItems.length})</h33>
  //         //         <div class="vdetails">
  //         //          ${categoryItems.map((option, index) => `
  //         //             <div class="vdetail-row">
  //         //                 <span class="vd-label">${index + 1}</span>
  //         //                 <span class="vd-value">${option.menuName}</span>
  //         //             </div>
  //         //         `).join("")}
  //         //     </div>
  //         // `;
  //       }

  //       afternoonOtherHtml += generateOtherFieldsHtml(AfternoonOther, afternoonMealType);

  //       //Night HTML
  //       // const groupedOptionsForNight = nightSelectedOptions.reduce((groups, option) => {
  //       //   const category = option?.category?.categoryName || "Unknown_Category";
  //       //   if (!groups[category]) {
  //       //     groups[category] = [];
  //       //   }
  //       //   groups[category].push(option);
  //       //   return groups;
  //       // }, {});

  //       // ✅ sort first by category.sortOrder
  //       const groupedOptionsForNight = nightSelectedOptions
  //         .sort(
  //           (a, b) =>
  //             (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
  //         )
  //         .reduce((groups, option) => {
  //           const categoryKey =
  //             option?.category?.categoryName || "Unknown_Category";

  //           if (!groups[categoryKey]) {
  //             groups[categoryKey] = [];
  //           }

  //           groups[categoryKey].push(option);
  //           return groups;
  //         }, {});

  //       let nightHtml = '';
  //       let nightOtherHtml = '';
  //       let nightIndex = 0;
  //       for (const categoryName in groupedOptionsForNight) {
  //         const categoryItems = groupedOptionsForNight[categoryName];

  //         const categoryBgColor = (nightIndex % 2 === 0) ? '#4f726c' : '#14312c';
  //         const menuBgColor = (nightIndex % 2 === 0) ? '#14312c' : '#4f726c';

  //         nightIndex++;
  //         nightHtml += `
  //                       <tr>
  //                           <td 
  //                               class="category-column" 
  //                               style="
  //                                   width: 20%; 
  //                                   background-color: #f8f9fa; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-weight: bold;
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
  //                           </td>
  //                           <td 
  //                               class="menu-column" 
  //                               style="
  //                                   width: 80%; 
  //                                   background-color: #ffffff; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
  //                           </td>
  //                       </tr>
  //                   `;

  //         // nightHtml += `
  //         //        <h3 style="margin: 0px;font-weight: 600;text-align: start;">${categoryName === 'Unknown_Category' ? 'Other' : categoryName} (${categoryItems.length})</h3>
  //         //         <div class="vdetails">
  //         //          ${categoryItems.map((option, index) => `
  //         //             <div class="vdetail-row">
  //         //                 <span class="vd-label">${index + 1}</span>
  //         //                 <span class="vd-value">${option.menuName}</span>
  //         //             </div>
  //         //         `).join("")}
  //         //     </div>
  //         // `;
  //       }

  //       if (inputValue?.bName && inputValue.bTotalPerson && inputValue.bPrice) {
  //         nightHtml += `
  //                       <tr>
  //                           <td 
  //                               class="category-column" 
  //                               style="
  //                                   width: 20%; 
  //                                   background-color: #f8f9fa; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-weight: bold;
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${t('breakfast')}
  //                           </td>
  //                           <td 
  //                               class="menu-column" 
  //                               style="
  //                                   width: 80%; 
  //                                   background-color: #ffffff; 
  //                                   color: black; 
  //                                   padding: 4px 6px; 
  //                                   font-size: 14px;
  //                                   vertical-align: top;
  //                                   border: 1px solid black;
  //                               ">
  //                               ${inputValue?.bName}
  //                           </td>
  //                       </tr>
  //                   `;
  //       }
  //       nightOtherHtml += generateOtherFieldsHtml(NightOther, nightMealType);

  //       // const printWindow = window.open("", "_blank");

  //       const printContent = `
  //                      <html>
  //                   <head>
  //                       <style>
  //                           body {
  //                               font-family: Arial, sans-serif;
  //                               margin: 0;
  //                               padding: 0;
  //                               color: white;
  //                           }

  //                           .container {
  //                               width: 800px;
  //                               margin: auto;
  //                               background: #ffffff;
  //                           }

  //                           /* Header Section */
  //                           .header {
  //                               text-align: center;
  //                               /* padding-bottom: 10px; */
  //                           }

  //                           .header img {
  //                               width: 100px;
  //                           }

  //                           .details {
  //                               display: flex;
  //                               flex-wrap: wrap;
  //                               justify-content: space-between;
  //                               /* border: 2px solid #14312c; */
  //                               /* Dark green background color */
  //                               /* background-color: #4f726c; */
  //                               /* Soft green background */
  //                               padding: 15px;
  //                               /* margin: 20px 0; */
  //                           }

  //                           .details div {
  //                               width: 46%;
  //                               margin-bottom: 10px;
  //                               font-size: 14px;
  //                           }

  //                           .details div strong {
  //                               font-weight: bold;
  //                           }

  //                           .menu-section {
  //                               margin: 10px 0;
  //                             /*  border: 2px solid #006400; */
  //                               /* Dark green border */
  //                           }

  //                           .menu-title {
  //                               background: #006400;
  //                               /* Dark green background */
  //                               color: #ffffff;
  //                               text-align: center;
  //                               padding: 8px;
  //                               font-size: 20px;
  //                               font-weight: bold;
  //                           }

  //                           .menu-items {
  //                               padding: 15px 0px;
  //                           }

  //                           .menu-items table {
  //                               width: 100%;
  //                               border-collapse: collapse;
  //                               margin: 0;
  //                           }

  //                           .menu-items th,
  //                           .menu-items td {
  //                               border: 1px solid black;
  //                               padding: 4px 6px;
  //                               text-align: left;
  //                               font-size: 14px;
  //                               color: black;
  //                           }

  //                           .menu-items th {
  //                               background-color: #f8f9fa;
  //                               color: black;
  //                               font-weight: bold;
  //                           }

  //                           .menu-items tr:nth-child(even) {
  //                               background-color: #f8f9fa;
  //                           }

  //                           .menu-items tr:nth-child(odd) {
  //                               background-color: #ffffff;
  //                           }

  //                           .footer {
  //                               text-align: center;
  //                               margin-top: 20px;
  //                               font-size: 16px;
  //                               font-weight: bold;
  //                               color: #006400;
  //                           }

  //                             .two-column-layout {
  //                                 display: grid;
  //                                 grid-template-columns: 1fr 1fr;
  //                                 gap: 10px;
  //                                 width: 100%;
  //                             }

  //                             .two-column-layout .table-container {
  //                                 width: 100%;
  //                             }

  //                             .two-column-layout table {
  //                                 width: 100%;
  //                                 margin-bottom: 0;
  //                             }

  //                           @media print {
  //                               @page {
  //                                   margin: 0;
  //                                   padding: 30px;
  //                               }

  //                               body {
  //                                   margin: 0;
  //                                   padding: 30px;
  //                                   font-family: Arial, sans-serif;
  //                               }

  //                               .print-button {
  //                                   display: none;
  //                               }

  //                               /* Apply a border to each page */
  //                               .container {
  //                                   page-break-before: always;
  //                               }

  //                               .page-break {
  //                                   page-break-before: always;
  //                               }

  //                               body:not(.background-graphics) {
  //                                   color: black !important;
  //                               }
  //                           }
  //                       </style>
  //                   </head>
  //                   <body>
  //                       <div class="container">
  //                           ${morningOptions && morningOptions.length > 0 ? `

  //                           <div style="display: flex;flex-wrap: wrap;color: #000000;justify-content: space-between;
  //                                           border: 1px solid;background-color: #4f726c;">

  //                               <div style="width: 78%;">
  //                                   <div class="details" style="margin-bottom: 0px;padding: 0px;padding-top:15px;">
  //                                       <div style="padding-left: 15px;"><strong>${t('Farm_Name')}:</strong> ${farm?.farmName}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Party_Name')}:</strong> ${partyName}</div>
  //                                       <div style="padding-left: 15px;"><strong>${t('Contact_Number')}:</strong> ${contactNumber}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Event_Date')}:</strong> ${moment(eventDate).format('DD-MM-YYYY')}</div>
  //                                       <div style="width:100%;padding-left: 15px;padding-right: 15px;"><strong>${t('Farm_Address')}:</strong> ${farm?.address}</div>
  //                                   </div>
  //                               </div>
  //                               <div style="width: 20%;display: flex;justify-content: center;align-items: center;">
  //                                   <div class="header">
  //                                       <img src="${pdflogoSrc}" alt="Logo">
  //                                   </div>
  //                               </div>
  //                               <div style="display: flex;background-color: #14312c;flex-wrap: wrap;width: 96%;justify-content: space-between;align-items: center;padding: 10px 15px;margin: auto;">
  //                                   <div style="text-align: left; flex: 1;">
  //                                       <strong>${moment(eventDate).format('DD-MM-YYYY')} :</strong> - ${t('Morning')}
  //                                   </div>
  //                                   <div style="text-align: center; flex: 1;"><strong>Code :</strong> - ${morningAmountCode}</div>
  //                                   <div style="text-align: right; flex: 1;">
  //                                       <strong>${t('dish')} :-</strong> ${mTotalPerson ? mTotalPerson : 0}
  //                                   </div>
  //                               </div>
  //                           </div>

  //                           <div class="two-column-layout">
  //                             <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       <table style="width: 100%; border-collapse: collapse; margin: 0;">
  //                                           <thead>
  //                                               <tr>
  //                                                   <th style="width: 20%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Category</th>
  //                                                   <th style="width: 80%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Menu Items</th>
  //                                               </tr>
  //                                           </thead>
  //                                           <tbody>
  //                                               ${MorningHtml}
  //                                           </tbody>
  //                                       </table>
  //                                   </div>
  //                               </div>
  //                             </div>
  //                              <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       ${MorningOtherHtml}
  //                                   </div>
  //                               </div>
  //                             </div>
  //                           </div>

  //                           ${afternoonselectedOptions && afternoonselectedOptions.length > 0 ? `
  //                           <div class="page-break"></div>` : ``}
  //                           ${afternoonselectedOptions.length === 0 && (nightSelectedOptions && nightSelectedOptions.length > 0 || inputValue.bName) ? `
  //                            <div class="page-break"></div>` : ``}

  //                           ` : ""}

  //                           <!-- Afternoon Section -->
  //                           ${afternoonselectedOptions && afternoonselectedOptions.length > 0 ? `

  //                           <div style="display: flex;flex-wrap: wrap;color: #000000;justify-content: space-between;
  //                                           border: 1px solid;background-color: #4f726c;">

  //                               <div style="width: 78%;">
  //                                   <div class="details" style="margin-bottom: 0px;padding: 0px;padding-top:15px;">
  //                                       <div style="padding-left: 15px;"><strong>${t('Farm_Name')}:</strong> ${farm?.farmName}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Party_Name')}:</strong> ${partyName}</div>
  //                                       <div style="padding-left: 15px;"><strong>${t('Contact_Number')}:</strong> ${contactNumber}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Event_Date')}:</strong> ${moment(eventDate).format('DD-MM-YYYY')}</div>
  //                                       <div style="width:100%;padding-left: 15px;padding-right: 15px;"><strong>${t('Farm_Address')}:</strong> ${farm?.address}</div>
  //                                   </div>
  //                               </div>
  //                               <div style="width: 20%;display: flex;justify-content: center;align-items: center;">
  //                                   <div class="header">
  //                                       <img src="${pdflogoSrc}" alt="Logo">
  //                                   </div>
  //                               </div>
  //                               <div style="display: flex;background-color: #14312c;flex-wrap: wrap;width: 96%;justify-content: space-between;align-items: center;padding: 10px 15px;margin: auto;">
  //                                   <div style="text-align: left; flex: 1;">
  //                                       <strong>${moment(eventDate).format('DD-MM-YYYY')} :</strong> - ${t('Afternoon')}
  //                                   </div>
  //                                   <div style="text-align: center; flex: 1;"><strong>Code :</strong> - ${afternoonAmountCode}</div>
  //                                   <div style="text-align: right; flex: 1;">
  //                                       <strong>${t('dish')} :-</strong> ${aTotalPerson ? aTotalPerson : 0}
  //                                   </div>
  //                               </div>
  //                           </div>

  //                            <div class="two-column-layout">
  //                             <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       <table style="width: 100%; border-collapse: collapse; margin: 0;">
  //                                           <thead>
  //                                               <tr>
  //                                                   <th style="width: 20%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Category</th>
  //                                                   <th style="width: 80%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Menu Items</th>
  //                                               </tr>
  //                                           </thead>
  //                                           <tbody>
  //                                               ${afternoonHtml}
  //                                           </tbody>
  //                                       </table>
  //                                   </div>
  //                               </div>
  //                             </div>
  //                              <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       ${afternoonOtherHtml}
  //                                   </div>
  //                               </div>
  //                             </div>
  //                           </div>

  //                         ${(nightSelectedOptions && nightSelectedOptions.length > 0) || (inputValue.bTotal > 0) ? `<div class="page-break"></div>` : ``}

  //                           ` : ""}

  //                           <!-- Night Section -->

  //                           ${(nightSelectedOptions && nightSelectedOptions.length > 0) || (inputValue.bTotal > 0) ? `
  //                               <div style="display: flex;flex-wrap: wrap;color: #000000;justify-content: space-between;
  //                                           border: 1px solid;background-color: #4f726c;">

  //                               <div style="width: 78%;">
  //                                   <div class="details" style="margin-bottom: 0px;padding: 0px;padding-top:15px;">
  //                                       <div style="padding-left: 15px;"><strong>${t('Farm_Name')}:</strong> ${farm?.farmName}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Party_Name')}:</strong> ${partyName}</div>
  //                                       <div style="padding-left: 15px;"><strong>${t('Contact_Number')}:</strong> ${contactNumber}</div>
  //                                       <div style="padding-right: 15px;"><strong>${t('Event_Date')}:</strong> ${moment(eventDate).format('DD-MM-YYYY')}</div>
  //                                       <div style="width:100%;padding-left: 15px;padding-right: 15px;"><strong>${t('Farm_Address')}:</strong> ${farm?.address}</div>
  //                                   </div>
  //                               </div>
  //                               <div style="width: 20%;display: flex;justify-content: center;align-items: center;">
  //                                   <div class="header">
  //                                       <img src="${pdflogoSrc}" alt="Logo">
  //                                   </div>
  //                               </div>
  //                               <div style="display: flex;background-color: #14312c;flex-wrap: wrap;width: 96%;justify-content: space-between;align-items: center;padding: 10px 15px;margin: auto;">
  //                                   <div style="text-align: left; flex: 1;">
  //                                       <strong>${moment(eventDate).format('DD-MM-YYYY')} :</strong> - ${t('Night')}
  //                                   </div>
  //                                   <div style="text-align: center; flex: 1;"><strong>Code :</strong> - ${nightAmountCode}</div>
  //                                   <div style="text-align: right; flex: 1;">
  //                                       <strong>${t('dish')} :-</strong> ${nTotalPerson ? nTotalPerson : 0}
  //                                   </div>
  //                               </div>
  //                           </div>


  //                           <div class="two-column-layout">
  //                             <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       <table style="width: 100%; border-collapse: collapse; margin: 0;">
  //                                           <thead>
  //                                               <tr>
  //                                                   <th style="width: 20%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Category</th>
  //                                                   <th style="width: 80%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold; font-size: 16px; border: 1px solid black;">Menu Items</th>
  //                                               </tr>
  //                                           </thead>
  //                                           <tbody>
  //                                               ${nightHtml}
  //                                           </tbody>
  //                                       </table>
  //                                   </div>
  //                               </div>
  //                             </div>
  //                              <div class="table-container">
  //                               <div class="menu-section">
  //                                   <div class="menu-items">
  //                                       ${nightOtherHtml}
  //                                   </div>
  //                               </div>
  //                             </div>
  //                           </div>
  //                           ` : ""}
  //                       </div>

  //               <script>
  //                   document.addEventListener('DOMContentLoaded', function () {
  //                       // Table layout automatically handles column heights
  //                       // No additional JavaScript needed for table-based layout
  //                   });
  //               </script>
  //                   </body>
  //                   </html>
  //                   `;

  //       handlePrintData(printContent);
  //       // setPrintHtmlContent(printContent);
  //       // setIsOpenPrintPreview(true);
  //     }
  //   }
  // };

  const handlePrint = () => {

    if (morningOptions.length === 0 && afternoonselectedOptions.length === 0 && nightSelectedOptions.length === 0) {
      showErrorToast(t('Menu_Print_Er'));
      return;
    }

    if (selectedOrder) {
      const { partyName, farm, contactNumber, eventDate } = selectedOrder;

      const {
        mTotalPerson,
        aTotalPerson,
        nTotalPerson,
      } = inputValue;

      const morningAmountCode = numToCode(inputValue.mPrice);
      const afternoonAmountCode = numToCode(inputValue.aPrice);
      const nightAmountCode = numToCode(inputValue.nPrice);

      if (morningOptions || afternoonselectedOptions || nightSelectedOptions) {

        // Morning HTML
        // ✅ sort by category.sortOrder first
        const groupedOptions = morningOptions
          .sort(
            (a, b) =>
              (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
          )
          .reduce((groups, option) => {
            const categoryKey =
              option?.category?.categoryName || "Unknown_Category";

            if (!groups[categoryKey]) {
              groups[categoryKey] = [];
            }

            groups[categoryKey].push(option);
            return groups;
          }, {});

        let MorningHtml = '';
        let MorningOtherHtml = '';
        let index = 0;
        for (const categoryName in groupedOptions) {
          const categoryItems = groupedOptions[categoryName];

          const categoryBgColor = (index % 2 === 0) ? '#4f726c' : '#14312c';
          const menuBgColor = (index % 2 === 0) ? '#14312c' : '#4f726c';

          index++;
          MorningHtml += `
                          <tr>
                              <td 
                                  class="category-column-a" 
                                  style="width: 20%; background-color: #f8f9fa; color: black; padding: 4px 6px; font-weight: bold;font-size: 14px;vertical-align: top;border: 1px solid black;">
                                  ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
                              </td>
                              <td 
                                  class="menu-column-a" 
                                  style="width: 80%; background-color: #ffffff; color: black; padding: 4px 6px; font-size: 14px;vertical-align: top;border: 1px solid black;">
                                  ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
                              </td>
                          </tr>
                      `;
        }

        MorningOtherHtml += generateOtherFieldsHtml(MorningOther, morningMealType);

        //Afternoon HTML
        // ✅ sort by category.sortOrder first
        const groupedOptionsForAfternoon = afternoonselectedOptions
          .sort(
            (a, b) =>
              (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
          )
          .reduce((groups, option) => {
            const categoryKey =
              option?.category?.categoryName || "Unknown_Category";

            if (!groups[categoryKey]) {
              groups[categoryKey] = [];
            }

            groups[categoryKey].push(option);
            return groups;
          }, {});

        let afternoonHtml = '';
        let afternoonOtherHtml = '';
        let afternoonIndex = 0;
        for (const categoryName in groupedOptionsForAfternoon) {
          const categoryItems = groupedOptionsForAfternoon[categoryName];

          const categoryBgColor = (afternoonIndex % 2 === 0) ? '#4f726c' : '#14312c';
          const menuBgColor = (afternoonIndex % 2 === 0) ? '#14312c' : '#4f726c';

          afternoonIndex++;
          afternoonHtml += `
                          <tr>
                              <td 
                                  class="category-column-a" 
                                  style="
                                      width: 20%; 
                                      background-color: #f8f9fa; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-weight: bold;
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
                              </td>
                              <td 
                                  class="menu-column-a" 
                                  style="
                                      width: 80%; 
                                      background-color: #ffffff; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
                              </td>
                          </tr>
                      `;
        }

        afternoonOtherHtml += generateOtherFieldsHtml(AfternoonOther, afternoonMealType);

        // ✅ sort first by category.sortOrder
        const groupedOptionsForNight = nightSelectedOptions
          .sort(
            (a, b) =>
              (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0)
          )
          .reduce((groups, option) => {
            const categoryKey =
              option?.category?.categoryName || "Unknown_Category";

            if (!groups[categoryKey]) {
              groups[categoryKey] = [];
            }

            groups[categoryKey].push(option);
            return groups;
          }, {});

        let nightHtml = '';
        let nightOtherHtml = '';
        let nightIndex = 0;
        for (const categoryName in groupedOptionsForNight) {
          const categoryItems = groupedOptionsForNight[categoryName];

          const categoryBgColor = (nightIndex % 2 === 0) ? '#4f726c' : '#14312c';
          const menuBgColor = (nightIndex % 2 === 0) ? '#14312c' : '#4f726c';

          nightIndex++;
          nightHtml += `
                          <tr>
                              <td 
                                  class="category-column" 
                                  style="
                                      width: 20%; 
                                      background-color: #f8f9fa; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-weight: bold;
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${categoryName === 'Unknown_Category' ? 'Other' : categoryName}
                              </td>
                              <td 
                                  class="menu-column" 
                                  style="
                                      width: 80%; 
                                      background-color: #ffffff; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${categoryItems.map(option => `${option.menuName}`).join("<br>")}
                              </td>
                          </tr>
                      `;
        }

        if (inputValue?.bName && inputValue.bTotalPerson && inputValue.bPrice) {
          nightHtml += `
                          <tr>
                              <td 
                                  class="category-column" 
                                  style="
                                      width: 20%; 
                                      background-color: #f8f9fa; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-weight: bold;
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${t('breakfast')}
                              </td>
                              <td 
                                  class="menu-column" 
                                  style="
                                      width: 80%; 
                                      background-color: #ffffff; 
                                      color: black; 
                                      padding: 4px 6px; 
                                      font-size: 14px;
                                      vertical-align: top;
                                      border: 1px solid black;
                                  ">
                                  ${inputValue?.bName}
                              </td>
                          </tr>
                      `;
        }
        nightOtherHtml += generateOtherFieldsHtml(NightOther, nightMealType);

        // const printWindow = window.open("", "_blank");

        const printContent = `
  <!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <style>
          @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap');

          body {
              font-family: 'Outfit', sans-serif;
              margin: 0;
              padding: 0;
              background-color: #fdf9f3;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
          }

          .page-container {
              width: 210mm;
              min-height: 297mm;
              margin: 0 auto;
              background: #fdf9f3;
              position: relative;
              /* overflow: hidden; Removed to prevent clipping of fixed elements if they were inside, though watermark is now outside */
          }
         
          .header-section {
              /* background-color: #446d73; */
              background-color: #5F6F64; 
              color: white;
              position: relative;
              padding: 30px 34px 10px 34px;
              margin: 0px 0px;
          }

          .header-title {
          padding-left:168px;
              // text-align: center;
              font-size: 24px;
              font-weight:700;
          }
               .header-right {
               margin-top: 10px;
               margin-bottom: 6px;
               padding-right: 40px;
              text-align: right;
              font-size: 13px;
              line-height: 1.6;
              color: #5F6F64;
          }

 .header-left{
 position: absolute;
 left:34px;
 top:16px
 }

          .header-left .logo img {
              width: 140px;
          }
.header-right .contact-name {
              font-size: 18px;
              line-height: 20px;
              font-weight: 500;
              // color: #F6F2E4;
          }



          .royal-divider {
              height: 1px;
              width: 80%;
              justify-self: center;
              background: linear-gradient(to right, transparent, #C6A75E, transparent);
              margin-bottom: 6px;
          }
          
          .header-section1 {
              display: flex;
              justify-content: space-between;
              align-items: center;
          }

          

         

          
          .info-card {
              margin: 4px 40px 10px 40px;
              padding: 2px;
              border-radius: 8px;
              box-shadow: 0 2px 10px rgba(0,0,0,0.08);
              position: relative;
              z-index: 10;
              border: 1px solid #e0e0e0;
              display: grid;
              grid-template-columns: 1.9fr 1fr;
              // background: white;
          }

          .info-card-left {
              padding: 10px 14px;
              border-right: 2px solid #5F6F64;
          }

          .info-card-right {
              padding: 10px 14px;
              border-radius: 0 8px 8px 0;
          }

          .info-item {
              display: flex;
              margin-bottom: 5px;
              font-size: 14px;
          }

          .info-label {
              font-weight: 600;
              color: #5F6F64;
              width: 112px;
              flex-shrink: 0;
          }

          .info-value {
              color: #333;
              border-bottom: 1px solid #ddd;
              flex-grow: 1;
              padding-left: 5px;
              font-weight: 600;
          }

          .meal-banner-container {
              /* padding: 0 40px; */
              margin-bottom: 10px;
              display: flex;
              justify-content: end;
          }

          .meal-banner {
              border: 1px solid #e0e0e0;
              border-radius: 6px;
              padding: 8px 30px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.05);
              // background: white;
          }

          .meal-type {
              font-weight: 700;
              font-size: 20px;
              color: #333;
          }

          .content-layout {
              display: grid;
              grid-template-columns: 1fr 300px;
              gap: 20px;
              padding: 4px 40px;
              position: relative;
              z-index: 1;
          }

          .menu-grid {
              padding-right: 10px;
          }

          .category-row {
              display: flex;
              margin-bottom: 10px;
              align-items: flex-start;
              /* border-bottom: 1px solid #5F6F64; */
              page-break-inside: avoid !important;
              break-inside: avoid !important;

          }

          .category-name {
              width: 120px;
              color: #5F6F64;
              font-weight: 600;
              font-size: 15px;
              text-align: left;
              padding-right: 15px;
              margin-top: 2px;
              flex-shrink: 0;
              border-right: 2px solid #5F6F64;
              margin-right: 15px;
          }
          
          .menu-items-list {
            flex-grow: 1;
            font-size: 14px;
            font-weight: 550;
            color: #333333;
            line-height: 1.5;
            border-bottom: 1px solid #5F6F64;
            }
            
            .menu-item {
              margin-bottom: 2px;
              page-break-inside: avoid;
              break-inside: avoid;
              }
    
          .extra-section {
              // padding: 16px;
              // border-radius: 8px;
              // border: 1px solid #e0e0e0;
              // height: fit-content;
              // background: white;
          }

          .extra-header {
              color: #306957;
              font-size: 22px;
              font-weight: 600;
              text-align: center;
              margin-bottom: 20px;
              border-bottom: 2px solid #306957;
          }

          .watermark {
              position: absolute;
              top: 55%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 500px;
              opacity: 0.03;
              z-index: 0;
              pointer-events: none;
          }

          .watermark img {
              width: 100%;
          }
              .page-break {
               page-break-before: always;
            }

          .footer-line {
              position: absolute;
              bottom: 8px;
              left: 0;
              width: 100%;
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              color: #ffff;
              background:#5F6F64;
              padding: 2px 0;
          }


          @media print {
               html, body {
               background-color: #fdf9f3;
               height: 100%;
               }
               .page-container {
                 box-shadow: none;
                 margin: 0;
                 width: 100%;
                 page-break-after: always !important; 
                 /*  page -break-before: always;*/
               }
                .watermark {
                        position: fixed;
                        top: 55%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 9999 !important; /* Force high z-index */
                        pointer-events: none;
                 }
                .page -break {
                   page -break-before: always;
                }
                  .footer-line {
                  position: fixed;
                  bottom: 8px;
                  left: 0;
                  width: 100%;
                }
               @page {
                 size: A4;
                 margin: 0;
                 padding: 0px;
               }
                 .print-background {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: -9999;
                    background-color: #fdf9f3;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                    pointer-events: none;
                  }
             }
      </style>
  </head>
  <body>
      ${[
            { options: morningOptions, type: 'Morning', code: morningAmountCode, total: mTotalPerson, otherHtml: generateOtherFieldsHtml(MorningOther, morningMealType) },
            { options: afternoonselectedOptions, type: 'Afternoon', code: afternoonAmountCode, total: aTotalPerson, otherHtml: generateOtherFieldsHtml(AfternoonOther, afternoonMealType) },
            { options: nightSelectedOptions, type: 'Night', code: nightAmountCode, total: nTotalPerson, otherHtml: generateOtherFieldsHtml(NightOther, nightMealType) }
          ].filter(section => section.options && section.options.length > 0).map((section, idx) => {

            const grouped = section.options
              .sort((a, b) => (a.category?.sortOrder || 0) - (b.category?.sortOrder || 0))
              .reduce((groups, option) => {
                const key = option?.category?.categoryName || "Other";
                if (!groups[key]) groups[key] = [];
                groups[key].push(option);
                return groups;
              }, {});
            const totalMenuItems = section.options.length;

            return `
          <div class="page-container ${idx > 0 ? 'page-break' : ''}">
            <div class="footer-line">
                Your trust is our greatest asset
            </div>
            <div class="print-background"></div>
            <div class="watermark">
                <img src="${pdflogoSrc}" alt="watermark">
            </div>


              <div class="header-section">
                <div class="header-title">New Radhika Sweets & Cateres</div>
                <div class="header-left">
                    <div class="logo">
                      <img src="${pdflogoSrc}" alt="logo">
                    </div>
                </div>
              </div>


              <div class="header-right">
                          <div class="contact-name">Sanjaybhai Trada</div>
                          <div>+91 95860 58604</div>
                          <div>newradhikacaterers1978@gmail.com</div>
                          <div>Surat, Gujarat</div>
                      </div>
                      <div class="royal-divider"></div>



              
              <div class="info-card">
                  <div class="info-card-left">
                      <div class="info-item">
                          <span class="info-label">${t('Party_Name')} :</span>
                          <span class="info-value">${partyName}</span>
                      </div>
                      <div class="info-item">
                          <span class="info-label">${t('Farm_Name')} :</span>
                          <span class="info-value">${farm?.farmName || farm}</span>
                      </div>
                      <div class="info-item">
                          <span class="info-label">${t('Contact_Number')} :</span>
                          <span class="info-value">${contactNumber}</span>
                      </div>
                      <div class="info-item">
                          <span class="info-label">${t('Farm_Address')} :</span>
                          <span class="info-value">${farm?.address || farm}</span>
                      </div>
                  </div>
                  <div class="info-card-right">
                      <div class="info-item">
                          <span class="info-label">${t('Event_Date')} :</span>
                          <span class="info-value">${moment(eventDate).format('DD-MM-YYYY')}</span>
                      </div>
                      <div class="info-item">
                          <span class="info-label">Code:</span>
                          <span class="info-value">${section.code}</span>
                      </div>
                      <div class="info-item">
                          <span class="info-label">${t('dish')} :</span>
                          <span class="info-value">${section.total || 0}</span>
                      </div>
                  </div>
              </div>

              

              <div class="content-layout">
                  <div class="menu-grid">
                      ${Object.entries(grouped).map(([catName, items]) => `
                        <div class="category-row">
                            <div class="category-name">${catName}</div>
                            <div class="menu-items-list">
                                ${totalMenuItems > 24
                ? `<div class="menu-item">${items.map(item => item.menuName).join(', ')}</div>`
                : items.map(item => `<div class="menu-item">${item.menuName}</div>`).join('')
              }
                            </div>
                        </div>
                      `).join('')}
                  </div>
                  <div style=>
                    <div class="meal-banner-container">
                        <div class="meal-banner">
                           <div class="meal-type">${t(section.type)}</div>
                        </div>
                     </div>
                      <div class="extra-section">
                        ${section.otherHtml}
                      </div>
                  </div>
                  <div class="page -break"></div>
              </div>
          </div>
          `;
          }).join('')}
          <script>
      window.onload = function() {
        const images = document.getElementsByTagName('img');
        let loaded = 0;
        const total = images.length;
        if (total === 0) {
          window.print();
        } else {
          for (let i = 0; i < total; i++) {
            if (images[i].complete) {
              loaded++;
              if (loaded === total) window.print();
            } else {
              images[i].onload = () => {
                loaded++;
                if (loaded === total) window.print();
              };
              images[i].onerror = () => {
                loaded++;
                if (loaded === total) window.print();
              };
            }
          }
        }
      };
    </script>
  </body>
  </html>
  `;
        // setPrintContent(printContent)
        handlePrintDataForPrint(printContent);
        // setPrintHtmlContent(printContent);
        // setIsOpenPrintPreview(true);
      }
    }
  };


  const handlePrintDataForPrint = (htmlContent) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    iframe.style.visibility = "hidden";
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(htmlContent);
    doc.close();
    setLoading(false);
    // iframe.contentWindow.focus();
    // iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = () => {
      document.body.removeChild(iframe);
    };
  };

  const handlePrintData = (htmlContent) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    iframe.style.visibility = "hidden";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(htmlContent);
    doc.close();

    setLoading(false);

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    iframe.contentWindow.onafterprint = () => {
      document.body.removeChild(iframe);
    };
  };




  const handlePrintMaterialPopup = () => {
    if (morningOptions.length === 0 && afternoonselectedOptions.length === 0 && nightSelectedOptions.length === 0) {
      showErrorToast(t('Menu_Print_Er'));
      return;
    }

    if (selectedOrder?.isInventoryUpdated) {
      handlePrintMaterial(false);
      return;
    }

    setIsOpenPrintMaterial(true);
  }

  const handlePrintInvoice = () => {
    if (morningOptions.length === 0 && afternoonselectedOptions.length === 0 && nightSelectedOptions.length === 0) {
      showErrorToast(t('Menu_Print_Er'));
      return;
    }

    getBillhtml(selectedOrder._id, {
      onSuccess: async (res) => {
        if (res?.data?.htmlContent) {
          setLoading(false);
          handlePrintData(res.data.htmlContent);
          // handlePrints(res.data.htmlContent);
        } else {
          setLoading(false);
        }
      },
      onError: (err) => {
        setLoading(false);
      },
    });
  }

  const handlePrints = (htmlContent) => {
    // const printWindow = window.open("", "_blank");
    // printWindow.document.open();
    // printWindow.document.write(htmlContent);
    // printWindow.document.close();
    // printWindow.print();
    handlePrintData(htmlContent);
  };

  const handlePrintMaterial = (isReduceStock) => {
    setLoading(true);

    if (selected.option1) {
      //diffrent
      getOrderhtml({ selectedIds: [selectedOrder._id], lang, isReduceStock: selected.option2 }, {
        onSuccess: async (res) => {
          if (res?.data?.htmlContent) {
            setLoading(false);
            handlePrintData(res.data.htmlContent);
          } else {
            setLoading(false);
          }
        },
        onError: (err) => {
          setLoading(false);
        },
      });

    } else {
      //Same
      getHtmlContent({ selectedIds: [selectedOrder._id], lang, isReduceStock: selected.option2 }, {
        onSuccess: async (res) => {
          const { success, htmlContent, pdfUrl, message, categoryPdfs, orderList } = res?.data || {};

          // if(categoryPdfs){
          //     setCategoryPdfsList(categoryPdfs)
          // }

          // if (success && pdfUrl) {
          //     setLoading(false);
          //     setPrintPdfUrl(pdfUrl);
          //     setPrintHtmlContent('');
          //     setIsOpenPrintPreview(true);
          //     return;
          // }

          // if (success && htmlContent) {
          //     setLoading(false);
          //     handlePrintData(htmlContent);
          //     return;
          // }


          if (!success) {
            showErrorToast(message);
            setLoading(false);
            return;
          }

          if (orderList) {
            setOrderList(orderList)
          }

          if (success && pdfUrl) {
            setPrintPdfUrl(pdfUrl);
          }

          if (res?.data?.htmlContent) {
            setLoading(false);
            // Replace the literal string "base64Imagedata" with actual base64 image data
            const htmlWithBase64 = res.data.htmlContent.replace(/base64Imagedata/g, base64Imagedata);
            // Open preview modal with editable content instead of printing directly
            setPrintHtmlContent(htmlWithBase64);
            setIsOpenPrintPreview(true);
          } else {
            setLoading(false);
          }

          setLoading(false);
          showErrorToast(message ? message : "Something went wrong...");
        },
        onError: (err) => {
          setLoading(false);
        },
      });
    }
  };


  const handlePrintFromModal = () => {
    // if (printPdfUrl) {
    //     const pdfWindow = window.open(printPdfUrl, '_blank');
    //     pdfWindow?.focus();
    //     pdfWindow?.print();
    // } else {
    //     handlePrintData(printHtmlContent);
    // }
    // setIsOpenPrintPreview(false);
    // setPrintPdfUrl('');

    const baseHtml = printHtmlWithPlaceholders || printHtmlContent;

    const updatedHtml = reconstructHtmlWithQuantities(baseHtml, editableQuantities);
    handlePrintData(updatedHtml);
    setIsOpenPrintPreview(false);
  };

  const handleShareFromModal = async () => {
    try {
      // Create a blob from the HTML content
      const baseHtml = printHtmlWithPlaceholders || printHtmlContent;
      const updatedHtml = reconstructHtmlWithQuantities(baseHtml, editableQuantities);

      const blob = new Blob([updatedHtml], { type: 'text/html' });
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = `order-${selectedOrder?.partyName || 'menu'}-${moment(selectedOrder?.eventDate).format('DD-MM-YYYY')}.html`;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      URL.revokeObjectURL(url);

      showSuccessToast(t('File downloaded successfully'));
    } catch (error) {
      console.error('Error sharing file:', error);
      showErrorToast(t('Error sharing file'));
    }
  };

  const updateOrderListFromEditableQuantities = () => {
    if (!orderList) return;

    const updatedOrderList = orderList.map(order => {
      // Deep copy menus
      const updateMenu = menu =>
        Object.fromEntries(
          Object.entries(menu).map(([category, items]) => [
            category,
            items.map(item => {
              const edited = editableQuantities.find(
                q => q.internalId === item._internalQtyId && q.isModified
              );

              if (edited) {
                return { ...item, quantity: edited.value };
              }
              return item;
            })
          ])
        );

      return {
        ...order,
        morningMenu: updateMenu(order.morningMenu),
        afternoonMenu: updateMenu(order.afternoonMenu),
        nightMenu: updateMenu(order.nightMenu)
      };
    });

    return updatedOrderList;
  };

  const sharedPDF = async (pdfUrl, categoryPdfs, htmlContent) => {

    if (pdfUrl) {
      const { farm, eventDate } = selectedOrder;

      // Build list of selected category-specific PDF links (if any)
      const selectedCategories = Object.entries(categoryCheckboxes)
        .filter(([, checked]) => checked)
        .map(([key]) => key);

      const links = [];

      if (selectedCategories.length > 0 && categoryPdfs && Object.keys(categoryPdfs).length > 0) {
        selectedCategories.forEach((catKey) => {
          const url = categoryPdfs[catKey].pdfUrl;

          if (url) {
            // Nicely formatted label (first letter upper, rest lower)
            const label = catKey.charAt(0).toUpperCase() + catKey.slice(1).toLowerCase();
            links.push({ label, url });
          }
        });
      }

      // Fallback: if no category-specific URLs resolved, send the main PDF URL
      if (links.length === 0) {
        links.push({ label: 'All', url: pdfUrl });
      }

      let message = `Order Details\n\n`;
      message += `Event Date: ${moment(eventDate).format('DD-MM-YYYY')}\n`;
      message += `Farm: ${farm?.farmName}\n`;
      message += `Address: ${farm?.address}\n\n`;

      if (links.length === 1 && links[0].label === 'All') {
        message += `PDF Link: ${links[0].url}`;
      } else if (links.length === 1) {
        message += `PDF Link (${links[0].label}): ${links[0].url}`;
      } else {
        message += `PDF Links:\n`;
        links.forEach((link) => {
          message += `- ${link.label}: ${link.url}\n`;
        });
      }

      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank');
      setIsWhatsAppLoading(false);
      return;
    }
  }

  const handleWhatsAppShare = async () => {
    try {

      setIsWhatsAppLoading(true);
      const hasModifications = editableQuantities.some(q => q.isModified);

      if (hasModifications) {
        console.log("⚠ Detected modified quantities. Updating orderList...");
        const updatedList = updateOrderListFromEditableQuantities();
        getUpdatedMaterialURLS({ selectedIds: [selectedOrder._id], lang, isReduceStock: selected.option2, updatedOrderList: updatedList }, {
          onSuccess: (res) => {
            setIsWhatsAppLoading(false);
            const { success, htmlContent, pdfUrl, message, categoryPdfs, orderList } = res?.data || {};
            console.log("Received updated HTML/PDF:", htmlContent, pdfUrl);

            if (success) {
              sharedPDF(pdfUrl, categoryPdfs, htmlContent)
              return;
            }
          },
          onError: (error) => {
            setIsWhatsAppLoading(false);
            console.error("Error updating order:", error);
            showErrorToast(t('Failed to update order'));
          }
        });

        return;
      }

      if (printPdfUrl) {
        const { farm, eventDate } = selectedOrder;

        // Build list of selected category-specific PDF links (if any)
        const selectedCategories = Object.entries(categoryCheckboxes)
          .filter(([, checked]) => checked)
          .map(([key]) => key);

        const links = [];

        if (selectedCategories.length > 0 && categoryPdfsList && Object.keys(categoryPdfsList).length > 0) {
          selectedCategories.forEach((catKey) => {
            const url = categoryPdfsList[catKey].pdfUrl;

            if (url) {
              // Nicely formatted label (first letter upper, rest lower)
              const label = catKey.charAt(0).toUpperCase() + catKey.slice(1).toLowerCase();
              links.push({ label, url });
            }
          });
        }

        // Fallback: if no category-specific URLs resolved, send the main PDF URL
        if (links.length === 0) {
          links.push({ label: 'All', url: printPdfUrl });
        }

        let message = `Order Details\n\n`;
        message += `Event Date: ${moment(eventDate).format('DD-MM-YYYY')}\n`;
        message += `Farm: ${farm?.farmName}\n`;
        message += `Address: ${farm?.address}\n\n`;

        if (links.length === 1 && links[0].label === 'All') {
          message += `PDF Link: ${links[0].url}`;
        } else if (links.length === 1) {
          message += `PDF Link (${links[0].label}): ${links[0].url}`;
        } else {
          message += `PDF Links:\n`;
          links.forEach((link) => {
            message += `- ${link.label}: ${link.url}\n`;
          });
        }

        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
        window.open(whatsappUrl, '_blank');
        setLoading(false);
        setIsWhatsAppLoading(false);
        return;
      }

      // Otherwise fall back to generating a PDF from the HTML content as before
      setLoading(true);

      // Create a temporary div to render the HTML content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = printHtmlContent;
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      tempDiv.style.width = '800px';
      tempDiv.style.backgroundColor = 'white';
      document.body.appendChild(tempDiv);

      // Wait for images to load
      const images = tempDiv.querySelectorAll('img');
      const imagePromises = Array.from(images).map(img => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        });
      });

      await Promise.all(imagePromises);

      // Generate PDF using html2canvas and jsPDF
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: 800,
        height: tempDiv.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      // Add first page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add additional pages if needed
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Generate PDF blob
      const pdfBlob = pdf.output('blob');
      const fileName = `order-${selectedOrder?.partyName || 'menu'}-${moment(selectedOrder?.eventDate).format('DD-MM-YYYY')}.pdf`;

      // Clean up temporary elements
      document.body.removeChild(tempDiv);

      // Check if we're on WhatsApp Web or desktop
      const isDesktop = !navigator.userAgent.match(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
      const isWhatsAppWeb = window.location.hostname.includes('web.whatsapp.com') ||
        document.referrer.includes('web.whatsapp.com') ||
        window.opener?.location?.hostname?.includes('web.whatsapp.com');

      // For WhatsApp Web or desktop browsers, open WhatsApp Web with a message
      if (isDesktop || isWhatsAppWeb) {
        const { partyName, farm, contactNumber, eventDate } = selectedOrder;
        const { mTotalPerson, aTotalPerson, nTotalPerson } = inputValue;

        let message = `Order Details\n\n`;
        message += `Event Date: ${moment(eventDate).format('DD-MM-YYYY')}\n`;
        message += `Farm: ${farm?.farmName}\n`;
        message += `Address: ${farm?.address}\n\n`;

        if (morningOptions.length > 0) {
          message += `🌅 *Morning Menu (${mTotalPerson || 0} dishes)${morningMealType ? ` - ${translateMealType(morningMealType)}` : ''}:*\n`;
          const morningCategories = morningOptions.reduce((groups, option) => {
            const category = option?.category?.categoryName || "Other";
            if (!groups[category]) groups[category] = [];
            groups[category].push(option.menuName);
            return groups;
          }, {});

          Object.entries(morningCategories).forEach(([category, items]) => {
            message += `• *${category}:* ${items.join(', ')}\n`;
          });
          message += `\n`;
        }

        if (afternoonselectedOptions.length > 0) {
          message += `☀️ *Afternoon Menu (${aTotalPerson || 0} dishes)${afternoonMealType ? ` - ${translateMealType(afternoonMealType)}` : ''}:*\n`;
          const afternoonCategories = afternoonselectedOptions.reduce((groups, option) => {
            const category = option?.category?.categoryName || "Other";
            if (!groups[category]) groups[category] = [];
            groups[category].push(option.menuName);
            return groups;
          }, {});

          Object.entries(afternoonCategories).forEach(([category, items]) => {
            message += `• *${category}:* ${items.join(', ')}\n`;
          });
          message += `\n`;
        }

        if (nightSelectedOptions.length > 0) {
          message += `🌙 *Night Menu (${nTotalPerson || 0} dishes)${nightMealType ? ` - ${translateMealType(nightMealType)}` : ''}:*\n`;
          const nightCategories = nightSelectedOptions.reduce((groups, option) => {
            const category = option?.category?.categoryName || "Other";
            if (!groups[category]) groups[category] = [];
            groups[category].push(option.menuName);
            return groups;
          }, {});

          Object.entries(nightCategories).forEach(([category, items]) => {
            message += `• *${category}:* ${items.join(', ')}\n`;
          });
        }

        message += `\n📄 *PDF Document:* ${fileName}`;

        // Download PDF first
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);

        // Open WhatsApp Web with pre-filled message
        const encodedMessage = encodeURIComponent(message);
        const whatsappWebUrl = `https://web.whatsapp.com/send?text=${encodedMessage}`;
        window.open(whatsappWebUrl, '_blank');

        setLoading(false);
        setIsWhatsAppLoading(false);
        showSuccessToast(t('PDF downloaded and WhatsApp Web opened. Please attach the PDF manually.'));
        return;
      }

      // Try to use Web Share API for mobile devices
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [new File([pdfBlob], fileName, { type: 'application/pdf' })] })) {
        try {
          const file = new File([pdfBlob], fileName, { type: 'application/pdf' });
          await navigator.share({
            title: `Order Details - ${selectedOrder?.partyName || 'Menu'}`,
            text: `Order details for ${selectedOrder?.partyName || 'Menu'} - ${moment(selectedOrder?.eventDate).format('DD-MM-YYYY')}`,
            files: [file]
          });
          setLoading(false);
          setIsWhatsAppLoading(false);
          showSuccessToast(t('PDF shared successfully via WhatsApp'));
          return;
        } catch (shareError) {
          console.log('Web Share API failed, falling back to download:', shareError);
        }
      }

      // Final fallback: Download PDF and show instructions
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      URL.revokeObjectURL(pdfUrl);

      setLoading(false);
      setIsWhatsAppLoading(false);
      showSuccessToast(t('PDF downloaded. Please share it manually via WhatsApp.'));

    } catch (error) {
      console.error('Error generating PDF for WhatsApp:', error);
      setLoading(false);
      setIsWhatsAppLoading(false);
      showErrorToast(t('Error generating PDF for WhatsApp'));
    }
  };

  const showList = () => {
    setIsShowMorningDrawer(!IsShowMorningDrawer);
  };

  const onDeleteItem = (isDelete) => {
    if (isDelete) {
      if (selectedTime === 'morning') {
        removeMenuItem(isDeleteItem);
      } else if (selectedTime === 'afternoon') {
        removeMenuItemForAfternoon(isDeleteItem);
      } else if (selectedTime === 'night') {
        removeMenuItemForNight(isDeleteItem)
      }
    }
    setisOpenDelete(false)
  }

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  const handleClosePopup = async (isRefresh) => {
    setPopupOpen(false);
    setIsEdit(false);
    setIsEditItem(undefined);
    if (isRefresh) {
      getOrderByID();
    }
  };

  const getUnitTypes = (unitType) => {
    if (!unitType) return '-';
    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ (Gram)';
      case 'kgs':
        return 'કિગ્રા (KGS)';
      case 'liter':
        return 'લિટર (Liter)';
      case 'ml':
        return 'મિલીલીટર (ML)';
      case 'pieces':
        return 'નંગ (Pieces)';
      case 'per_person':
        return 'માણસો દીઠ (Per Person)';
      case 'roll':
        return 'રોલ (Roll)';
      case 'person':
        return 'માણસ (Person)';
      case 'event':
        return 'ઇવેન્ટ (Event)';
      default:
        return unitType;
    }
  }

  const getUnitTypesForPrint = (unitType) => {
    if (!unitType) return '-';

    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ';
      case 'kgs':
        return 'કિગ્રા';
      case 'liter':
        return 'લિટર';
      case 'ml':
        return 'મિલીલીટર';
      case 'pieces':
        return 'નંગ';
      case 'per_person':
        return 'માણસો દીઠ';
      case 'roll':
        return 'રોલ';
      case 'person':
        return 'માણસ';
      case 'event':
        return 'ઇવેન્ટ';
      default:
        return unitType;
    }
  };


  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Header Section */}
        <div className="bg-white shadow-sm border-b">
          <div className=" mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-6">
              <div className="
                                flex flex-col 
                                lg:flex-row 
                                justify-between 
                                lg:items-center
                                space-y-4 
                                lg:space-y-0
                            ">

                {/* LEFT SIDE */}
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => { setIsOpenConfirm(true); }}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                  >
                    <img alt='back' src={Left_arrow} width={20} height={20} className="cursor-pointer" />
                  </button>

                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center">
                      <FaClipboardList className="text-white text-lg" />
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold text-gray-900">{t('OrderDetailstitle')}</h1>
                      <p className="text-sm text-gray-500">{t('manage_order_details')}</p>
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE BUTTONS (NOW RESPONSIVE) */}
                <div className="
                                    flex 
                                    flex-col 
                                    sm:flex-row 
                                    sm:flex-wrap 
                                    gap-3
                                    w-full 
                                    lg:w-auto
                                ">

                  <ButtonWithIcon text={t('btnPrintInvoice')} variant='secondary' btnclass="bg-blue-600 text-white hover:bg-blue-700" onClick={handlePrintInvoice} Icon={FaFileInvoiceDollar} />
                  <ButtonWithIcon text={t('btnPrintMenu')} variant='secondary' btnclass="bg-green-600 hover:bg-green-700" onClick={handlePrint} Icon={FaPrint} />
                  <ButtonWithIcon text={t('printMaterial')} variant='secondary' btnclass="bg-purple-600 hover:bg-purple-700" onClick={handlePrintMaterialPopup} Icon={FaBoxes} />
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Main Content */}
        <div className=" mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Order Information Card */}
          <div className="bg-white rounded-lg shadow-sm border mb-8">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center">
                  <FaUser className="mr-2 text-secondary" />
                  {/* Order Information */}
                  {t('Order_information')}
                </h2>
                <ButtonWithIcon text={t('edit')} variant='secondary' btnclass="text-gray-500 hover:text-secondary hover:bg-secondary/10 px-3 text-sm font-semibold" onClick={(e) => {
                  e.stopPropagation()
                  setIsEdit(true)
                  setIsEditItem(selectedOrder)
                  handleOpenPopup(true)
                }} Icon={EditIcon} title="Edit Order Information" iconClass='mr-2' />
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <InfoItem icon={FaUser} label={t('Party_Name')} value={selectedOrder?.farm?.farmName || 'N/A'} />
                <InfoItem icon={FaHotel} label={t('Farm_Name')} value={selectedOrder?.partyName || 'N/A'} />
                <InfoItem icon={FaPhone} label={t('Contact_Number')} value={selectedOrder?.contactNumber || 'N/A'} />
                <InfoItem icon={FaCalendarDay} label={t('Event_Date')} value={selectedOrder?.eventDate ? moment(selectedOrder?.eventDate).format('DD-MM-YYYY') : 'N/A'} />
                <InfoItem icon={FaMapMarkerAlt} label={t('Farm_Address')} value={selectedOrder?.farm?.address || 'N/A'} />
              </div>
            </div>
          </div>

          {/* Menus */}
          <div className="space-y-6">
            {/* Morning Section */}
            <CollapsibleCard
              icon={FaSun}
              iconClass="text-yellow-500 text-xl"
              title={t('Morning')}
              isOpen={IsShowMorningDrawer}
              onToggle={showList}
              ref={morningContentRef}
            >
              {/* children go here */}
              <div className="px-6 pb-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Menu Selection */}
                  <MenuSelectionSection
                    title={t('menu_selection')}
                    prefix="morning"
                    options={morningOptions}
                    setOptions={setMorningOptions}
                    isPopoverOpen={isPopoverOpen}
                    closeOtherPopovers={() => {
                      setAfternoonPopoverOpen(false)
                      setNightPopoverOpen(false)
                    }}
                    togglePopover={togglePopover}
                    menuOptionsRef={menuOptionsRef}
                    searchInputRef={searchInputRef}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    filteredMenuLists={filteredMenuLists}
                    handleCheckboxChange={handleCheckboxChange}
                    categoryList={categoryList}
                    selectedCategoryIndex={selectedCategoryIndex}
                    setSelectedCategoryIndex={setSelectedCategoryIndex}
                    showPreviousCategory={showPreviousCategory}
                    showNextCategory={showNextCategory}
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    categorySearch={categorySearch}
                    setCategorySearch={setCategorySearch}
                    categoryOptionsRef={categoryOptionsRef}
                    setSelectedTime={setSelectedTime}
                    setIsDeleteItem={setIsDeleteItem}
                    setisOpenDelete={setisOpenDelete}
                  />

                  {/* Pricing and Details */}
                  <MealServiceSection
                    title={t('Morning')}
                    mealPrefix="m"
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    handleChange={handleChange}
                    calcMeal={calcMorning}
                    mealType={morningMealType}
                    setMealType={setMorningMealType}
                    mealTypeOptions={mealTypeOptions}
                    OtherState={MorningOther}
                    updateOther={updateMorningOther}
                    handleNumericChange={handleNumericChange}
                    isLoading={isLoading}
                    t={t}
                  />
                </div>
                {/* Morning Miscellaneous - Full Width Table */}
                <MiscellaneousSection
                  titlePrefix="M"
                  miscList={morningMisc}
                  setMiscList={setMorningMisc}
                  unitList={unitList}
                  getUnitTypes={getUnitTypes}
                  t={t}
                  lang={lang}
                  onAddClick={() => {
                    setMiscSection('morning')
                    setTempMiscSelection(morningMisc || [])
                    setIsMiscModalOpen(true)
                  }}
                />
              </div>


            </CollapsibleCard>
            {/* End of Morning Section */}

            {/* AFTER NOON SECTION */}
            <CollapsibleCard
              icon={FaCloudSun}
              iconClass="text-orange-500"
              title={t('Afternoon')}
              isOpen={IsShowAfternoonDrawer}
              ref={afternoonContentRef}
              onToggle={() => setIsShowAfternoonDrawer(!IsShowAfternoonDrawer)}
            >
              <div className="px-6 pb-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Menu Selection */}
                  <MenuSelectionSection
                    title={t('menu_selection')}
                    prefix="afternoon"
                    options={afternoonselectedOptions}
                    setOptions={setAfternoonSelectedOptions}
                    isPopoverOpen={isAfternoonPopoverOpen}
                    closeOtherPopovers={() => {
                      setPopoverOpen(false);
                      setNightPopoverOpen(false);
                    }}
                    togglePopover={togglePopoverAfternoon}
                    menuOptionsRef={afternoonRef}
                    searchInputRef={searchInputRef}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    filteredMenuLists={filteredMenuLists}
                    handleCheckboxChange={handleCheckboxChangeForAfternoon}
                    categoryList={categoryList}
                    selectedCategoryIndex={selectedCategoryIndex}
                    setSelectedCategoryIndex={setSelectedCategoryIndex}
                    showPreviousCategory={showPreviousCategory}
                    showNextCategory={showNextCategory}
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    categorySearch={categorySearch}
                    setCategorySearch={setCategorySearch}
                    categoryOptionsRef={categoryOptionsRef}
                    setSelectedTime={setSelectedTime}
                    setIsDeleteItem={setIsDeleteItem}
                    setisOpenDelete={setisOpenDelete}
                  />

                  {/* Pricing and Details */}
                  <MealServiceSection
                    // title={t('Morning')}
                    mealPrefix="a"
                    inputValue={inputValue}
                    handleChange={handleChange}
                    calcMeal={calcAfternoon}
                    mealType={afternoonMealType}
                    setMealType={setAfternoonMealType}
                    mealTypeOptions={mealTypeOptions}
                    OtherState={AfternoonOther}
                    updateOther={updateAfternoonOther}
                    handleNumericChange={handleNumericChange}
                    isLoading={isLoading}
                    t={t}
                  />
                </div>
                {/* Afternoon Miscellaneous - Full Width Table */}
                <MiscellaneousSection
                  titlePrefix="M"
                  miscList={afternoonMisc}
                  setMiscList={setAfternoonMisc}
                  unitList={unitList}
                  getUnitTypes={getUnitTypes}
                  t={t}
                  lang={lang}
                  onAddClick={() => {
                    setMiscSection('afternoon');
                    setTempMiscSelection(afternoonMisc || []);
                    setIsMiscModalOpen(true);
                  }}
                />
              </div>
            </CollapsibleCard>

            {/* Night Section */}
            <CollapsibleCard
              icon={FaMoon}
              iconClass="text-blue-500"
              title={t('Night')}
              isOpen={IsShowNightDrawer}
              ref={nightContentRef}
              onToggle={() => setIsShowNightDrawer(!IsShowNightDrawer)}
            >
              <div className="px-6 pb-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Menu Selection */}

                  <MenuSelectionSection
                    title={t('menu_selection')}
                    prefix="night"
                    options={nightSelectedOptions}
                    setOptions={setNightSelectedOptions}
                    isPopoverOpen={isNightPopoverOpen}
                    closeOtherPopovers={() => {
                      setPopoverOpen(false);
                      setAfternoonPopoverOpen(false);
                    }}
                    togglePopover={togglePopoverNight}
                    menuOptionsRef={nightRef}
                    searchInputRef={searchInputRef}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    filteredMenuLists={filteredMenuLists}
                    handleCheckboxChange={handleCheckboxChangeForNight}
                    categoryList={categoryList}
                    selectedCategoryIndex={selectedCategoryIndex}
                    setSelectedCategoryIndex={setSelectedCategoryIndex}
                    showPreviousCategory={showPreviousCategory}
                    showNextCategory={showNextCategory}
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    categorySearch={categorySearch}
                    setCategorySearch={setCategorySearch}
                    categoryOptionsRef={categoryOptionsRef}
                    setSelectedTime={setSelectedTime}
                    setIsDeleteItem={setIsDeleteItem}
                    setisOpenDelete={setisOpenDelete}
                  />

                  {/* Pricing and Details */}
                  <MealServiceSection
                    // title={t('Morning')}
                    mealPrefix="n"
                    inputValue={inputValue}
                    handleChange={handleChange}
                    calcMeal={calcNight}
                    mealType={nightMealType}
                    setMealType={setNightMealType}
                    mealTypeOptions={mealTypeOptions}
                    OtherState={NightOther}
                    updateOther={updateNightOther}
                    handleNumericChange={handleNumericChange}
                    isLoading={isLoading}
                    t={t}
                  />
                </div>

                {/* Night Miscellaneous full-width table */}
                <MiscellaneousSection
                  titlePrefix="M"
                  miscList={nightMisc}
                  setMiscList={setNightMisc}
                  unitList={unitList}
                  getUnitTypes={getUnitTypes}
                  t={t}
                  lang={lang}
                  onAddClick={() => {
                    setMiscSection('night');
                    setTempMiscSelection(nightMisc || []);
                    setIsMiscModalOpen(true);
                  }}
                />

              </div>

            </CollapsibleCard>
          </div>

          <div>
            <div className="bg-[#f7f7f7] rounded-lg shadow-sm border mt-6">
              <div className="flex items-center justify-between p-6">
                <div className="flex items-center space-x-3">
                  <h3 className="text-lg font-semibold text-gray-900">{t('breakfast')}</h3>
                </div>
              </div>
              <div className="px-6 pb-6">
                <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
                  <div className="space-y-4">

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-end">

                      <InputF name="bName"
                        label="bName" placeholder={t('name') || 'Name'} disabled={isLoading} handleInputChange={handleChange} value={inputValue?.bName} lName={t('name') || 'Name'} />

                      <InputF name="bPrice"
                        label="bPrice" placeholder={t('dish_price')} disabled={isLoading} handleInputChange={(e) => {
                          handleChange(e);
                          calcBreakfast();
                        }} value={inputValue?.bPrice} lName={t("dish_price")} />

                      <InputF name="bTotalPerson"
                        label="bTotalPerson" placeholder={t('Total_person')} disabled={isLoading} handleInputChange={(e) => {
                          handleChange(e);
                          calcBreakfast();
                        }} value={inputValue?.bTotalPerson} lName={t("Total_person")} />

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{t('Total')}</label>
                        <div className="w-full h-12 px-4 flex items-center rounded-lg bg-gray-100 border border-gray-300 text-sm font-bold text-secondary">
                          ₹{inputValue.bTotal || 0}
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>


          {/* Enhanced Order Summary Section */}
          <div className="bg-white rounded-lg shadow-sm border mt-8">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold text-gray-900">{t('order_summary')}</h2>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">{t('order_status')}:</span>
                  <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                    Active
                  </span>
                </div>
              </div>
            </div>

            <div className="p-6">
              {/* Detailed Breakdown */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-700 mb-3">{t('cost_breakdown')}</h3>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 text-sm">
                  <div className="F_JC_IC">
                    <span className="text-gray-600">{t('morning_services')}:</span>
                    <span className="font-medium">₹{inputValue.mTotal || 0}</span>
                  </div>
                  <div className="F_JC_IC">
                    <span className="text-gray-600">{t('breakfast_services')}:</span>
                    <span className="font-medium">₹{inputValue.bTotal || 0}</span>
                  </div>
                  <div className="F_JC_IC">
                    <span className="text-gray-600">{t('afternoon_services')}:</span>
                    <span className="font-medium">₹{inputValue.aTotal || 0}</span>
                  </div>
                  <div className="F_JC_IC">
                    <span className="text-gray-600">{t('night_services')}:</span>
                    <span className="font-medium">₹{inputValue.nTotal || 0}</span>
                  </div>
                  {/* <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Additional Services:</span>
                                    <span className="font-medium">₹{(MorningOther?.simpleWaiter?.total || 0) + (AfternoonOther?.simpleWaiter?.total || 0) + (NightOther?.simpleWaiter?.total || 0)}</span>
                                </div>
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Decoration:</span>
                                    <span className="font-medium">₹{(MorningOther?.decoration?.amount || 0) + (AfternoonOther?.decoration?.amount || 0) + (NightOther?.decoration?.amount || 0)}</span>
                                </div> */}
                  <div className="flex justify-between items-center border-t pt-2">
                    <span className="text-gray-800 font-semibold">{t('Total')}:</span>
                    <span className="text-gray-900 font-bold">₹{inputValue.totalAmount || 0}</span>
                  </div>
                </div>
              </div>

              {/* Financial Summary Cards */}
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
                {/* Total Amount */}
                <DataCard className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" Icon={TDueAmountIcon} title={t('total_due_amount')} desc={`₹${inputValue.totalAmount || 0}`} titleClass="text-blue-700" iconClass="bg-blue-500" descClass="text-blue-900" />

                {/* Paid Amount */}
                <DataCard className="bg-gradient-to-br from-green-50 to-green-100 border-green-200" Icon={PaidAmountIcon} title={t('paidby_client')} desc={`₹${inputValue.dueamount || 0}`} titleClass="text-green-700" iconClass="bg-green-500" descClass="text-green-900" isInput >
                  <InputF name="paidByClient"
                    label="paidByClient" placeholder="Enter amount" disabled={isLoading} handleInputChange={(e) => {
                      handleChange(e);
                      setTimeout(calcDueamount(e.target.value), 100);
                    }} value={inputValue?.paidByClient} className="!text-green-900 h-8 px-3 !border-green-300 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 !rounded" />
                </DataCard>

                {/* Due Amount */}
                <DataCard className="bg-gradient-to-br from-red-50 to-red-100 border-red-200" Icon={DueAmountIcon} title={t('due_amount')} desc={`₹${inputValue.dueamount || 0}`} titleClass="text-red-700" iconClass="bg-red-500" descClass="text-red-900" />

                {/* Payment Status */}
                <DataCard className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200" Icon={PayStatusIcon} title={t('due_amount')} desc={`₹${inputValue.dueamount || 0}`} titleClass="text-purple-700" iconClass="bg-purple-500" descClass="text-purple-900" />
              </div>


            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4 mt-8" >
            <ButtonWithIcon btnclass='text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium' text={t('btnCancel')} variant='secondary' onClick={() => { setIsOpenConfirm(true) }} Icon={FaTimes} />
            <ButtonWithIcon btnclass='bg-secondary hover:bg-secondary/90 px-8' text={t('btnSave')} variant='secondary' onClick={onSubmit} Icon={FaSave} disabled={isLoading} isLoading={isLoading} />
          </div>
        </div>
      </div>


      {/* Modals */}
      < DeleteModal isOpen={isOpenDelete} onClose={onDeleteItem} confirmMsg={t('Want_Delete_Item')} />

      {isOpenConfirm && (
        <div className="popup-overlay">
          <div className="popup-content !w-[400px] !p-6" onClick={(e) => e.stopPropagation()}>
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                <FaTimes className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('Are_u_sure')}</h3>
              <p className="text-sm text-gray-500 mb-6">{t('Are_u_desc')}</p>

              <div className="flex space-x-3">
                <button
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200"
                  onClick={() => { setIsOpenConfirm(false); }}
                >
                  {t('NO')}
                </button>
                <button
                  className="flex-1 px-4 py-2 bg-secondary hover:bg-secondary/90 text-white rounded-lg font-medium transition-colors duration-200"
                  onClick={() => {
                    setIsOpenConfirm(false);
                    navigate('/orders');
                  }}
                >
                  {t('yes')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )
      }

      {
        isOpenPrintMaterial && (
          <div className="popup-overlay">
            <div className="popup-content !w-[550px] !p-6" onClick={(e) => e.stopPropagation()}>
              <div className="flex justify-between items-center border-b border-gray-200 pb-4 mb-6">
                <h3 className="text-lg font-semibold text-gray-900">{t('materialTitle')}</h3>
                <button
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                  onClick={() => { setIsOpenPrintMaterial(false) }}
                >
                  <img src={Close} alt="Close" className="w-5 h-5" />
                </button>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    id="option1"
                    checked={selected.option1}
                    onChange={() => handleOptionCheckboxChange('option1')}
                    className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                  />
                  <label htmlFor="option1" className="text-sm text-gray-700">{t('option1')}</label>
                </div>
                <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    id="option2"
                    checked={selected.option2}
                    onChange={() => handleOptionCheckboxChange('option2')}
                    className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                  />
                  <label htmlFor="option2" className="text-sm text-gray-700">{t('option2')}</label>
                </div>
              </div>

              <div className="flex space-x-3">
                <button
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200"
                  onClick={() => { setIsOpenPrintMaterial(false); }}
                >
                  {t('btnCancel')}
                </button>
                <button
                  className="flex-1 px-4 py-2 bg-secondary hover:bg-secondary/90 text-white rounded-lg font-medium transition-colors duration-200"
                  onClick={() => {
                    setIsOpenPrintMaterial(false);
                    handlePrintMaterial(true);
                  }}
                >
                  {t('btnPrint')}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Print Preview Modal */}
      {isOpenPrintPreview && (
        <div className="popup-overlay">
          <div className="popup-content !w-[90vw] !max-w-[60rem] !h-[90vh] !p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center border-b border-gray-200 pb-4 mb-6">
              <h3 className="text-lg font-semibold text-gray-900">{t('Print Preview')}</h3>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                onClick={() => {
                  setIsOpenPrintPreview(false);
                  setPrintPdfUrl('');
                }}
              >
                <img src={Close} alt="Close" className="w-5 h-5" />
              </button>
            </div>

            <div className="flex flex-col h-[calc(90vh-140px)]">
              {/* HTML/PDF Preview */}
              {/* <div className="flex-1 overflow-auto border border-gray-300 rounded-lg mb-4">
                                <iframe
                                    src={printPdfUrl || undefined}
                                    srcDoc={!printPdfUrl ? printHtmlContent : undefined}
                                    className="w-full h-full border-0"
                                    title="Print Preview"
                                />
                            </div> */}

              {/* HTML Preview - Editable Quantities */}
              <div className="flex-1 overflow-auto border border-gray-300 rounded-lg mb-6 bg-white" style={{ height: 'calc(90vh - 200px)' }}>
                <div
                  ref={editableContentRef}
                  className="w-full h-full p-4"
                  style={{ minHeight: '100%', maxWidth: '900px', margin: 'auto' }}
                />
              </div>

              {/* Category Checkboxes */}
              <div className="mb-4">
                <div className="flex flex-wrap items-center gap-4">
                  <span className="text-sm font-medium text-gray-700 mr-2">
                    Select Category:
                  </span>
                  <div className="flex flex-wrap gap-4">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        id="category-vegetable"
                        checked={categoryCheckboxes.vegetable}
                        onChange={() => handleCategoryCheckboxChange('vegetable')}
                        className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Vegetable</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        id="category-grocery"
                        checked={categoryCheckboxes.grocery}
                        onChange={() => handleCategoryCheckboxChange('grocery')}
                        className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Grocery</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        id="category-dairy"
                        checked={categoryCheckboxes.dairy}
                        onChange={() => handleCategoryCheckboxChange('dairy')}
                        className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Dairy</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        id="category-vasan"
                        checked={categoryCheckboxes.vasan}
                        onChange={() => handleCategoryCheckboxChange('vasan')}
                        className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Vasan</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        id="category-farsan"
                        checked={categoryCheckboxes.farsan}
                        onChange={() => handleCategoryCheckboxChange('farsan')}
                        className="w-4 h-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Farsan</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-wrap justify-end gap-3">
                <button
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200"
                  onClick={() => {
                    setIsOpenPrintPreview(false);
                    setPrintPdfUrl('');
                  }}
                >
                  {t('btnCancel')}
                </button>
                {!printPdfUrl && (
                  <button
                    className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                    onClick={handleShareFromModal}
                  >
                    <FaSave className="text-sm" />
                    <span>{t('Download')}</span>
                  </button>
                )}
                <button
                  className="flex-1 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleWhatsAppShare}
                  disabled={isWhatsAppLoading}
                >
                  {isWhatsAppLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span>Processing...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                      </svg>
                      <span>{t('WhatsApp')}</span>
                    </>
                  )}
                </button>
                <button
                  className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                  onClick={handlePrintFromModal}
                >
                  <FaPrint className="text-sm" />
                  <span>{t('btnPrint')}</span>
                </button>
                {printPdfUrl && (
                  <button
                    className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                    onClick={() => {
                      const link = document.createElement('a');
                      link.href = printPdfUrl;
                      const fileName = printPdfUrl.split('/').pop()?.split('?')[0] || 'order-materials.pdf';
                      link.download = fileName;
                      link.target = '_blank';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <FaSave className="text-sm" />
                    <span>{t('Download')}</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Order Modal */}
      {isPopupOpen && (
        <AddOrder
          isOpen={isPopupOpen}
          onClose={handleClosePopup}
          isEdit={isEdit}
          isEditItem={isEditItem}
        />
      )}

      {/* Miscellaneous Selection Modal */}
      {isMiscModalOpen && (
        <div className="popup-overlay" onClick={() => setIsMiscModalOpen(false)}>
          <div className="popup-content !w-[800px] !p-0 overflow-hidden" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="px-6 py-4 border-b border-gray-200 bg-white flex items-center justify-between">
              <div className="text-lg font-semibold text-gray-900">{t('select_miscellaneous') || t('Select Miscellaneous') || 'Select Miscellaneous'}</div>
              <div className="text-sm text-red-600 font-medium">{t('selected') || t('Selected') || 'Selected'}: {tempMiscSelection?.length || 0}</div>
            </div>
            {/* Toolbar */}
            <div className="px-6 py-3 bg-gray-50 border-b border-gray-200 flex items-center gap-3">
              <div className="flex-1 relative">
                <input
                  type="text"
                  placeholder={t('search_miscellaneous_placeholder') || t('Search miscellaneous') || 'Search miscellaneous...'}
                  className="w-full h-10 pl-10 pr-3 border rounded-lg text-sm"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <svg className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
                </svg>
              </div>
              <div>
                <select className="h-10 border rounded-lg text-sm px-3" value={miscSort} onChange={(e) => setMiscSort(e.target.value)}>
                  <option value="name-asc">Sort by : A→Z</option>
                  <option value="name-desc">Sort by : Z→A</option>
                </select>
              </div>
            </div>
            {/* List */}
            <div className="px-6 py-2 max-h-[60vh] overflow-auto">
              {(() => {
                const selectedMap = new Map((tempMiscSelection || []).map(i => [i._id, true]));
                const resolveUnitKey = (val) => {
                  if (!val) return '';
                  const str = String(val).toLowerCase();
                  const byKey = unitList.find(u => u.key.toLowerCase() === str);
                  if (byKey) return byKey.key;
                  const byName = unitList.find(u => (u.name || '').toLowerCase() === str);
                  return byName ? byName.key : '';
                };
                const list = (allMiscellaneousItems || []).filter(i => {
                  const term = (searchText || '').toLowerCase().trim();
                  if (!term) return true;
                  const nameEn = i?.name?.en?.toLowerCase() || '';
                  const nameGu = i?.name?.gu?.toLowerCase() || '';
                  return nameEn.includes(term) || nameGu.includes(term);
                }).sort((a, b) => {
                  const aSel = selectedMap.has(a._id) ? 1 : 0;
                  const bSel = selectedMap.has(b._id) ? 1 : 0;
                  if (aSel !== bSel) return bSel - aSel; // selected first
                  const aName = (a?.name?.en || a?.name?.gu || '').toLowerCase();
                  const bName = (b?.name?.en || b?.name?.gu || '').toLowerCase();
                  if (miscSort === 'name-desc') return bName.localeCompare(aName);
                  return aName.localeCompare(bName);
                });
                const toggle = (item) => {
                  setTempMiscSelection(prev => prev.some(x => x._id === item._id) ? prev.filter(x => x._id !== item._id) : [item, ...prev]);
                };
                return list.map((item) => {
                  const isSelected = selectedMap.get(item._id);
                  const selectedData = (tempMiscSelection || []).find(x => x._id === item._id) || {};
                  const updateSelected = (updates) => {
                    setTempMiscSelection(prev => prev.map(x => x._id === item._id ? { ...x, ...updates } : x));
                  };
                  const currentUnitKey = resolveUnitKey(selectedData?.unit || item?.unit);
                  const unitName = (unitList.find(u => u.key === resolveUnitKey(item?.unit)) || {}).name || (item?.unit || '-');
                  const baseUnitName = (unitList.find(u => u.key === resolveUnitKey(item?.baseQuantityUnit)) || {}).name || (item?.baseQuantityUnit || '-');
                  return (
                    <div key={item._id} className={`flex items-center justify-between px-3 py-3 rounded-lg border ${isSelected ? 'bg-blue-50 border-blue-200' : 'bg-white border-gray-200'} mb-2`}>
                      <div className="flex items-center gap-3">
                        <button onClick={() => toggle(item)} className={`w-5 h-5 rounded-full flex items-center justify-center border ${isSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-300'}`}>
                          {isSelected && (
                            <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                        </button>
                        <div className="text-sm text-gray-800">
                          {lang === 'gu' ? item?.name?.gu : item?.name?.en}
                        </div>
                      </div>

                      <div className="flex items-center gap-3">
                        <button className={`text-xs px-3 py-1.5 rounded-md border ${isSelected ? 'border-red-300 text-red-700 bg-red-50' : 'border-gray-300 text-gray-700 bg-white'}`} onClick={() => toggle(item)}>
                          {isSelected ? (t('remove') || 'Remove') : (t('add') || 'Add')}
                        </button>
                      </div>
                    </div>
                  );
                });
              })()}
              {(!allMiscellaneousItems || allMiscellaneousItems.length === 0) && (
                <div className="text-sm text-gray-500 py-6 text-center">{t('no_data_found') || 'No data found'}</div>
              )}
            </div>
            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-200 bg-white flex items-center justify-end gap-2">
              <button className="px-4 py-2 rounded border" onClick={() => setIsMiscModalOpen(false)}>{t('btnCancel') || t('Cancel') || 'Cancel'}</button>
              <button
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                onClick={() => {
                  if (miscSection === 'morning') setMorningMisc(tempMiscSelection);
                  if (miscSection === 'afternoon') setAfternoonMisc(tempMiscSelection);
                  if (miscSection === 'night') setNightMisc(tempMiscSelection);
                  setIsMiscModalOpen(false);
                }}
              >
                {t('apply_selection') || t('Apply Selection') || 'Apply Selection'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderDetail;